var _excluded = ["columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "backgroundOverlayOpacity", "backgroundOverlayColor"],
  _excluded2 = ["width", "minWidth", "maxWidth"],
  _excluded3 = ["color"],
  _excluded4 = ["color"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { DEFAULT_FONT } from "../../builderUiTheme";
import { findBlockIcon } from "../constants/iconCatalog";
import { SINGLE_WEIGHT_FONT_NAMES, PDF_SKIP_STYLE_PROPS, BLOCK_TEXT_WRAP_CSS, TABLE_CELL_MIN_WIDTH, TABLE_CELL_WRAP_CSS, SPACING_SIDES, RADIUS_CORNERS, RADIUS_UNITS, SIZE_UNITS, SIZE_KEYWORD_UNITS, SPACING_UNITS, blocks, BLOCK_GAP_DEFAULTS } from "../constants/defaultBlocks";
export function cloneBlockContent(content) {
  if (!content) return {};
  return JSON.parse(JSON.stringify(content));
}
var blockIdSeq = 0;

/** Guaranteed-unique numeric id for builder blocks (avoids Date.now() collisions). */
export function createUniqueBlockId() {
  blockIdSeq += 1;
  // Date.now() + monotonic seq stays unique and within Number.MAX_SAFE_INTEGER.
  return Date.now() + blockIdSeq;
}
export function isNestedColumnContent(content) {
  return Array.isArray(content === null || content === void 0 ? void 0 : content.columns) && content.columns.length > 0 && Array.isArray(content.columns[0]);
}
function remapNestedBlockIds(node) {
  if (!node || _typeof(node) !== "object") return node;
  node.id = createUniqueBlockId();
  if (isNestedColumnContent(node.content)) {
    node.content.columns = (node.content.columns || []).map(function (col) {
      return Array.isArray(col) ? col.map(function (child) {
        return remapNestedBlockIds(child);
      }) : col;
    });
  }
  return node;
}

/**
 * Deep-clone a block (and nested column/group children) with fresh unique ids.
 * Use for copy / paste / duplicate so edits never sync across clones.
 */
export function cloneBlockNode(node) {
  if (!node) return null;
  return remapNestedBlockIds(JSON.parse(JSON.stringify(node)));
}
export var TWO_COLUMN_LABELS = ["Left Column Content", "Right Column Content"];
export var THREE_COLUMN_LABELS = ["Column 1 Content", "Column 2 Content", "Column 3 Content"];
export var MIN_LAYOUT_COLUMNS = 1;
export var MAX_LAYOUT_COLUMNS = 4;
/** Default top margin applied when a block/section is first added (shown in Style tab). */
export var DEFAULT_NEW_BLOCK_MARGIN_TOP = "3%";
export function isColumnLayoutType(type) {
  return type === "one-column" || type === "two-column" || type === "three-column";
}
export function getColumnLayoutType(columnCount) {
  var count = Math.max(MIN_LAYOUT_COLUMNS, Number(columnCount) || MIN_LAYOUT_COLUMNS);
  if (count <= 1) return "one-column";
  if (count === 2) return "two-column";
  return "three-column";
}
export function getColumnLayoutLabels(columnCount) {
  if (columnCount === 2) return TWO_COLUMN_LABELS;
  return Array.from({
    length: columnCount
  }, function (_, i) {
    return "Column ".concat(i + 1, " Content");
  });
}
export function getColumnBackgroundLabel(index, columnCount) {
  if (columnCount === 2) {
    return index === 0 ? "Left Column Background" : "Right Column Background";
  }
  return "Column ".concat(index + 1, " Background");
}
export function getLayoutColumnCount(content) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (isNestedColumnContent(content)) {
    return Math.max(fallback, content.columns.length);
  }
  return fallback;
}

/** Ensure newly created blocks get a visible default top margin in the Style tab. */
export function withDefaultNewBlockMargin() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = _objectSpread({}, style || {});
  if (next.marginTop == null || next.marginTop === "") {
    next.marginTop = DEFAULT_NEW_BLOCK_MARGIN_TOP;
  }
  return next;
}

/** Marker for list items: check (default), bullet, number or alpha. */
export function getListMarker(listStyle, index) {
  if (listStyle === "bullet") return "•";
  if (listStyle === "number") return "".concat(index + 1, ".");
  if (listStyle === "alpha") {
    var n = index;
    var s = "";
    do {
      s = String.fromCharCode(97 + n % 26) + s;
      n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    return "".concat(s, ".");
  }
  return "✓";
}

/** Map every node in the tree (including blocks nested inside column layouts). */
export function mapNodesRecursive(nodes, mapper) {
  return (nodes || []).map(function (node) {
    var _mapper;
    var mapped = (_mapper = mapper(node)) !== null && _mapper !== void 0 ? _mapper : node;
    if (isNestedColumnContent(mapped.content)) {
      return _objectSpread(_objectSpread({}, mapped), {}, {
        content: _objectSpread(_objectSpread({}, mapped.content), {}, {
          columns: mapped.content.columns.map(function (col) {
            return mapNodesRecursive(col, mapper);
          })
        })
      });
    }
    return mapped;
  });
}
export function updateNodeInTree(nodes, nodeId, updater) {
  return (nodes || []).map(function (node) {
    if (node.id === nodeId) {
      return updater(node);
    }
    if (isNestedColumnContent(node.content)) {
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), {}, {
          columns: node.content.columns.map(function (col) {
            return updateNodeInTree(col, nodeId, updater);
          })
        })
      });
    }
    return node;
  });
}
export function removeNodeFromTree(nodes, nodeId) {
  var filtered = (nodes || []).filter(function (node) {
    return node.id !== nodeId;
  });
  if (filtered.length !== (nodes || []).length) {
    return filtered;
  }
  return (nodes || []).map(function (node) {
    if (!isNestedColumnContent(node.content)) return node;
    return _objectSpread(_objectSpread({}, node), {}, {
      content: _objectSpread(_objectSpread({}, node.content), {}, {
        columns: node.content.columns.map(function (col) {
          return removeNodeFromTree(col, nodeId);
        })
      })
    });
  });
}
function createTextBlockNode(text, id) {
  return {
    id: id !== null && id !== void 0 ? id : createUniqueBlockId(),
    type: "text",
    content: {
      text: text
    },
    style: {}
  };
}
export function sanitizeBuilderNode(node) {
  var _content$columns, _node$id;
  if (!node || _typeof(node) !== "object" || !node.type) return null;
  var template = blocks.find(function (b) {
    return b.type === node.type;
  });
  var baseContent = cloneBlockContent((template === null || template === void 0 ? void 0 : template.content) || {});
  var rawContent = node.content && _typeof(node.content) === "object" ? node.content : {};
  var content = _objectSpread(_objectSpread({}, baseContent), rawContent);
  if (isColumnLayoutType(node.type)) {
    if (!isNestedColumnContent(content)) {
      if (node.type === "one-column") {
        content = {
          columns: [content.col1 ? [createTextBlockNode(content.col1)] : []]
        };
      } else if (node.type === "two-column") {
        content = {
          columns: [content.leftText ? [createTextBlockNode(content.leftText)] : [], content.rightText ? [createTextBlockNode(content.rightText)] : []]
        };
      } else {
        content = {
          columns: [content.col1 ? [createTextBlockNode(content.col1)] : [], content.col2 ? [createTextBlockNode(content.col2)] : [], content.col3 ? [createTextBlockNode(content.col3)] : []]
        };
      }
    } else {
      var cols = (content.columns || []).map(function (col) {
        return Array.isArray(col) ? sanitizeBuilderTree(col) : [];
      });
      while (cols.length < MIN_LAYOUT_COLUMNS) cols.push([]);
      content = {
        columns: cols.slice(0, MAX_LAYOUT_COLUMNS)
      };
    }
  } else if (isNestedColumnContent(content)) {
    content = _objectSpread(_objectSpread({}, content), {}, {
      columns: content.columns.map(function (col) {
        return Array.isArray(col) ? sanitizeBuilderTree(col) : [];
      })
    });
  }
  var normalizedType = isColumnLayoutType(node.type) ? getColumnLayoutType(((_content$columns = content.columns) === null || _content$columns === void 0 ? void 0 : _content$columns.length) || MIN_LAYOUT_COLUMNS) : node.type;
  return _objectSpread(_objectSpread({}, node), {}, {
    id: (_node$id = node.id) !== null && _node$id !== void 0 ? _node$id : Date.now(),
    type: normalizedType,
    content: content,
    style: node.style && _typeof(node.style) === "object" ? node.style : {},
    elementStyles: node.elementStyles && _typeof(node.elementStyles) === "object" ? node.elementStyles : undefined
  });
}
export function sanitizeBuilderTree(tree) {
  if (!Array.isArray(tree)) return [];
  return tree.map(sanitizeBuilderNode).filter(Boolean);
}
export function findNodeRecursive(nodes, nodeId) {
  var _iterator = _createForOfIteratorHelper(nodes || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      if (node.id === nodeId) return node;
      if (isNestedColumnContent(node.content)) {
        var _iterator2 = _createForOfIteratorHelper(node.content.columns),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var col = _step2.value;
            var found = findNodeRecursive(col, nodeId);
            if (found) return found;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
export function defaultBlockStyle(block) {
  var defaultMargins = {
    marginTop: DEFAULT_NEW_BLOCK_MARGIN_TOP,
    marginRight: "0",
    marginBottom: "0",
    marginLeft: "0"
  };
  if (block.type === "page-break") {
    return withDefaultNewBlockMargin(_objectSpread(_objectSpread({
      height: "1px"
    }, defaultMargins), {}, {
      marginBottom: "16px",
      padding: "0",
      background: "transparent"
    }, block.style || {}));
  }
  if (block.type === "divider") {
    return withDefaultNewBlockMargin(_objectSpread(_objectSpread({
      padding: "0"
    }, defaultMargins), {}, {
      marginBottom: "24px",
      borderRadius: "0",
      color: "#1C252E",
      background: "transparent",
      fontSize: "16px",
      textAlign: "left",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "#1C252E",
      width: "100%",
      boxSizing: "border-box"
    }, block.style || {}));
  }
  if (block.type === "image") {
    return withDefaultNewBlockMargin(_objectSpread(_objectSpread({
      padding: "0"
    }, defaultMargins), {}, {
      borderRadius: "0",
      color: "#334155",
      background: "transparent",
      fontSize: "16px",
      textAlign: "left",
      borderStyle: "none",
      borderWidth: "0px",
      borderColor: "#cbd5e1"
    }, block.style || {}));
  }
  if (block.type === "button") {
    return withDefaultNewBlockMargin(_objectSpread(_objectSpread({
      padding: "12px 28px"
    }, defaultMargins), {}, {
      borderRadius: "24px",
      color: "#ffffff",
      background: "#101828",
      fontSize: "16px",
      lineHeight: "1.4",
      textAlign: "left",
      borderStyle: "none",
      borderWidth: "0px",
      borderColor: "#cbd5e1",
      boxSizing: "border-box"
    }, block.style || {}));
  }
  return withDefaultNewBlockMargin(_objectSpread(_objectSpread({
    padding: "0"
  }, defaultMargins), {}, {
    borderRadius: "6px",
    color: "#334155",
    background: "transparent",
    fontSize: block.type === "heading" ? "32px" : "16px",
    // Keep room for ascenders/descenders when font-size is large
    lineHeight: block.type === "heading" ? "1.25" : "1.5",
    textAlign: "left",
    borderStyle: "none",
    borderWidth: "0px",
    borderColor: "#cbd5e1"
  }, block.style || {}));
}
export function escapeHtml(text) {
  if (text === undefined || text === null) return "";
  return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
var AI_RESULT_PREFIX_RE = /^AI Writer Suggestion:\s*|^Generated Content:\s*|^✨ Premium Project Proposal Intro:\s*|^⭐ Modern Project Pricing Plan:\s*|^🗣️ Client Testimonial:\s*|^⚡ Key Services & Core Offerings:\s*|^💡 Generated Copy suggestion:\s*/;
export function normalizeAiCopy(aiResult) {
  return String(aiResult !== null && aiResult !== void 0 ? aiResult : "").replace(AI_RESULT_PREFIX_RE, "").replace(/^```(?:html)?\s*/i, "").replace(/```\s*$/g, "").trim();
}
export function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value !== null && value !== void 0 ? value : ""));
}

/** Strip HTML tags so canvas text/heading blocks show rendered copy, not raw markup. */
export function aiResultToPlainText(aiResult) {
  var raw = normalizeAiCopy(aiResult);
  if (!looksLikeHtml(raw)) return raw;
  if (typeof document === "undefined") {
    return raw.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }
  var tmp = document.createElement("div");
  tmp.innerHTML = raw;
  return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
}
export function detectHeadingTagFromAi(aiResult) {
  var match = normalizeAiCopy(aiResult).match(/<(h[1-6])\b/i);
  return match ? match[1].toLowerCase() : "h1";
}

/** Use HTML as-is when present so the canvas renders it; otherwise wrap plain text. */
export function aiResultToHtmlCode(aiResult) {
  var raw = normalizeAiCopy(aiResult);
  if (looksLikeHtml(raw)) return raw;
  return "<div style=\"padding: 24px; background: #f8fafc; border-left: 4px solid #101828; border-radius: 6px;\"><p style=\"margin: 0; color: #1e293b; font-size: 15px; line-height: 1.6; white-space: pre-line;\">".concat(escapeHtml(raw), "</p></div>");
}
export function nl2br(text) {
  return escapeHtml(text).replace(/\n/g, "<br>");
}
export function getTableColumnCount(content) {
  var headerCount = ((content === null || content === void 0 ? void 0 : content.headers) || []).length;
  var rowMax = ((content === null || content === void 0 ? void 0 : content.rows) || []).reduce(function (max, row) {
    return Math.max(max, (row || []).length);
  }, 0);
  return Math.max(headerCount, rowMax, 1);
}
export function getTableElementStyle(colCount) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var minPx = colCount * TABLE_CELL_MIN_WIDTH;
  return _objectSpread({
    width: "max-content",
    minWidth: "max(100%, ".concat(minPx, "px)"),
    tableLayout: "auto",
    borderCollapse: "collapse"
  }, extra);
}
export function buildTableBlockWrapperCss() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$forPdf = options.forPdf,
    forPdf = _options$forPdf === void 0 ? false : _options$forPdf;
  var resolved = resolveBorderStyleProps(resolveStyleWithBackgroundOverlay(style || {}));
  var parts = ["width: 100%", "max-width: 100%", "overflow-x: auto", "box-sizing: border-box"];
  if (hasIndividualSpacing(style, "margin")) {
    SPACING_SIDES.forEach(function (s) {
      var val = style === null || style === void 0 ? void 0 : style["margin".concat(s.key)];
      if (val !== undefined && val !== null && val !== "") {
        parts.push("margin-".concat(s.key.toLowerCase(), ": ").concat(val));
      }
    });
  } else if ((style === null || style === void 0 ? void 0 : style.margin) !== undefined && (style === null || style === void 0 ? void 0 : style.margin) !== null && (style === null || style === void 0 ? void 0 : style.margin) !== "") {
    parts.push("margin: ".concat(style.margin));
  }
  if (hasIndividualSpacing(style, "padding")) {
    SPACING_SIDES.forEach(function (s) {
      var val = style === null || style === void 0 ? void 0 : style["padding".concat(s.key)];
      if (val !== undefined && val !== null && val !== "") {
        parts.push("padding-".concat(s.key.toLowerCase(), ": ").concat(val));
      }
    });
  } else if ((style === null || style === void 0 ? void 0 : style.padding) !== undefined && (style === null || style === void 0 ? void 0 : style.padding) !== null && (style === null || style === void 0 ? void 0 : style.padding) !== "") {
    parts.push("padding: ".concat(style.padding));
  }
  if ((style === null || style === void 0 ? void 0 : style.opacity) !== undefined && (style === null || style === void 0 ? void 0 : style.opacity) !== null && (style === null || style === void 0 ? void 0 : style.opacity) !== "") {
    parts.push("opacity: ".concat(style.opacity));
  }
  if (resolved.backgroundImage) {
    var bgImg = resolved.backgroundImage;
    if (typeof bgImg === "string" && bgImg.includes("url(")) {
      bgImg = bgImg.replace(/url\(\s*"([^"]*)"\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      }).replace(/url\(\s*'([^']*)'\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      });
    }
    parts.push("background-image: ".concat(bgImg));
    parts.push("background-size: ".concat(resolved.backgroundSize || "cover"));
    parts.push("background-position: ".concat(resolved.backgroundPosition || "center"));
    parts.push("background-repeat: ".concat(resolved.backgroundRepeat || "no-repeat"));
  } else if (style !== null && style !== void 0 && style.background) {
    var bg = forPdf ? gradientToSolid(style.background) || style.background : style.background;
    if (!String(bg).includes("gradient") || !forPdf) {
      parts.push("background: ".concat(bg));
    }
  }
  if (style !== null && style !== void 0 && style.backgroundColor) {
    parts.push("background-color: ".concat(style.backgroundColor));
  }
  var borderStyle = pickTableWrapperBorderStyle(style);
  Object.entries(borderStyle).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value === undefined || value === null || value === "") return;
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    parts.push("".concat(kebab, ": ").concat(value));
  });
  var radiusCss = buildBorderRadiusCss(style);
  if (radiusCss) {
    parts.push(radiusCss.replace(/;+\s*$/, ""));
  } else if (style !== null && style !== void 0 && style.borderRadius) {
    parts.push("border-radius: ".concat(style.borderRadius));
  }
  if (style !== null && style !== void 0 && style.boxShadow) parts.push("box-shadow: ".concat(style.boxShadow));
  if (style !== null && style !== void 0 && style.transform) {
    parts.push("transform: ".concat(style.transform));
    parts.push("transform-origin: center");
  }
  if (style !== null && style !== void 0 && style.clipPath) {
    parts.push("clip-path: ".concat(style.clipPath));
    parts.push("overflow: hidden");
  }
  if (style !== null && style !== void 0 && style.position && style.position !== "static") {
    parts.push("position: ".concat(style.position));
    ["top", "right", "bottom", "left", "zIndex"].forEach(function (key) {
      var val = style === null || style === void 0 ? void 0 : style[key];
      if (val !== undefined && val !== null && val !== "") {
        parts.push("".concat(key === "zIndex" ? "z-index" : key, ": ").concat(val));
      }
    });
  }
  return parts.join("; ");
}

/**
 * Outer table frame borders for canvas + preview.
 * Templates often use per-side borderTopWidth/… without borderWidth shorthand —
 * canvas used to ignore those and looked borderless vs preview.
 */
export function pickTableWrapperBorderStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var res = {};
  var perSideBorder = ["Top", "Right", "Bottom", "Left"].some(function (side) {
    return (style === null || style === void 0 ? void 0 : style["border".concat(side, "Width")]) !== undefined;
  });
  if (perSideBorder) {
    var fallbackStyle = style !== null && style !== void 0 && style.borderStyle && style.borderStyle !== "none" ? style.borderStyle : "solid";
    var fallbackColor = (style === null || style === void 0 ? void 0 : style.borderColor) || "#cbd5e1";
    ["Top", "Right", "Bottom", "Left"].forEach(function (side) {
      var w = style["border".concat(side, "Width")];
      var s = style["border".concat(side, "Style")] || fallbackStyle;
      var c = style["border".concat(side, "Color")] || fallbackColor;
      if (w === undefined || w === null || w === "" || s === "none") return;
      var n = parseFloat(String(w));
      if (!Number.isNaN(n) && n <= 0) return;
      res["border".concat(side)] = "".concat(w, " ").concat(s, " ").concat(c);
    });
  } else if (style !== null && style !== void 0 && style.borderWidth && style !== null && style !== void 0 && style.borderStyle && style.borderStyle !== "none") {
    res.border = "".concat(style.borderWidth, " ").concat(style.borderStyle, " ").concat(style.borderColor || "#cbd5e1");
  }
  return res;
}
export function getTableElementCss(colCount) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var minPx = colCount * TABLE_CELL_MIN_WIDTH;
  return "width: max-content; min-width: max(100%, ".concat(minPx, "px); table-layout: auto; border-collapse: collapse;").concat(extra ? " ".concat(extra) : "");
}
export function buildSignedSignatureHtml(signatureText) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "export";
  var trimmed = (signatureText || "").trim();
  if (!trimmed) {
    return variant === "pdf" ? "<div style=\"height: 40px; border-bottom: 2px solid #cbd5e1; margin-bottom: 6px;\"></div>" : "<div style=\"height: 50px; border-bottom: 2px solid #e2e8f0; margin-bottom: 10px;\"></div>";
  }
  var fontSize = variant === "pdf" ? 24 : 28;
  var borderColor = variant === "pdf" ? "#cbd5e1" : "#e2e8f0";
  var marginBottom = variant === "pdf" ? "6px" : "10px";
  return "<div style=\"font-family: 'Great Vibes', 'Pacifico', 'Dancing Script', cursive; font-size: ".concat(fontSize, "px; color: #4f46e5; border-bottom: 2px solid ").concat(borderColor, "; padding: 10px 0; margin-bottom: ").concat(marginBottom, ";\">").concat(escapeHtml(trimmed), "</div>");
}
export function getSocialIconSvgHtml(type) {
  var attrs = 'xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="display:block"';
  if (type === "facebook") {
    return "<svg ".concat(attrs, " fill=\"currentColor\"><path d=\"M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z\"/></svg>");
  }
  if (type === "twitter") {
    return "<svg ".concat(attrs, " fill=\"currentColor\"><path d=\"M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.7 0-1.37-.2-1.95-.54v.05c0 2.08 1.48 3.82 3.44 4.21-.36.1-.74.15-1.13.15-.27 0-.54-.03-.8-.08.54 1.68 2.1 2.9 3.95 2.94-1.44 1.12-3.26 1.8-5.23 1.8-.34 0-.67-.02-1-.06C2.62 21.02 4.88 22 7.28 22 14.81 22 18.9 15.77 18.9 10.37c0-.18 0-.35-.01-.53.8-.57 1.49-1.3 2.03-2.13z\"/></svg>");
  }
  if (type === "linkedin") {
    return "<svg ".concat(attrs, " fill=\"currentColor\"><path d=\"M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.8v8.37h2.8v-4.87c0-.26.05-.53.13-.72a1.11 1.11 0 0 1 1-.76c.55 0 1 .41 1 1.17v5.18h2.8M6.5 8.37a1.37 1.37 0 1 0 0-2.75 1.37 1.37 0 0 0 0 2.75M8 18.5V10.1H5.1v8.4H8z\"/></svg>");
  }
  if (type === "instagram") {
    return "<svg ".concat(attrs, " fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" ry=\"5\"/><path d=\"M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z\"/><line x1=\"17.5\" y1=\"6.5\" x2=\"17.51\" y2=\"6.5\"/></svg>");
  }
  return "";
}
export function buildSocialExportHtml(node, styleStr) {
  var _node$style, _node$style2;
  var iconColor = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.color) || "#475569";
  var align = ((_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.textAlign) || "center";
  var gap = resolveBlockGap(node.style, "14px");
  var justify = align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center";
  var networks = ["facebook", "twitter", "linkedin", "instagram"];
  var links = networks.filter(function (net) {
    var _node$content;
    return (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content[net];
  }).map(function (net) {
    return "<a href=\"".concat(escapeHtml(node.content[net]), "\" target=\"_blank\" style=\"display:inline-flex; color:").concat(iconColor, "; text-decoration:none; vertical-align:middle; line-height:0;\">").concat(getSocialIconSvgHtml(net), "</a>");
  }).join("");
  var padCss = styleHasSpacing(node.style, "padding") ? "" : "padding: 10px 0;";
  var marginCss = defaultBlockMarginCss(node.style);
  return "<div style=\"display:flex; flex-wrap:wrap; align-items:center; justify-content:".concat(justify, "; gap:").concat(gap, "; text-align: ").concat(align, "; ").concat(marginCss, " ").concat(padCss, " ").concat(styleStr, "\">").concat(links, "</div>");
}
export function getTreeFontFamily(tree) {
  var _nodeWithFont$style, _tree$;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FONT;
  if (!tree || !tree.length) return fallback;
  var nodeWithFont = tree.find(function (node) {
    var _node$style3;
    return (_node$style3 = node.style) === null || _node$style3 === void 0 ? void 0 : _node$style3.fontFamily;
  });
  return (nodeWithFont === null || nodeWithFont === void 0 || (_nodeWithFont$style = nodeWithFont.style) === null || _nodeWithFont$style === void 0 ? void 0 : _nodeWithFont$style.fontFamily) || ((_tree$ = tree[0]) === null || _tree$ === void 0 || (_tree$ = _tree$.style) === null || _tree$ === void 0 ? void 0 : _tree$.fontFamily) || fallback;
}
export function resolveNodeFontFamily(style, fallback) {
  return (style === null || style === void 0 ? void 0 : style.fontFamily) || fallback;
}
export function isSingleWeightFont(fontFamily) {
  if (!fontFamily) return false;
  var font = String(fontFamily);
  if (font.includes("cursive")) return true;
  return SINGLE_WEIGHT_FONT_NAMES.some(function (name) {
    return font.includes(name);
  });
}
export function resolveFontWeight(fontFamily, weight) {
  if (isSingleWeightFont(fontFamily)) return "normal";
  return weight || "normal";
}
export function getEffectiveElementStyle(node, elementKey, fallbackFont, fallbackWeight) {
  var _node$elementStyles, _merged$fontWeight;
  var blockStyle = (node === null || node === void 0 ? void 0 : node.style) || {};
  var elementStyle = elementKey && node !== null && node !== void 0 && (_node$elementStyles = node.elementStyles) !== null && _node$elementStyles !== void 0 && _node$elementStyles[elementKey] ? node.elementStyles[elementKey] : {};
  var merged = _objectSpread(_objectSpread({}, blockStyle), elementStyle);
  var font = resolveNodeFontFamily(merged, fallbackFont);
  var weight = resolveFontWeight(font, (_merged$fontWeight = merged.fontWeight) !== null && _merged$fontWeight !== void 0 ? _merged$fontWeight : fallbackWeight);
  return {
    merged: merged,
    font: font,
    weight: weight,
    elementStyle: elementStyle,
    blockStyle: blockStyle
  };
}

/** Canvas render: only element-specific overrides — block wrapper keeps default design via inheritance. */
/** Layout props that belong on the block shell, not nested text/list parts. */
export var BLOCK_LAYOUT_STYLE_KEYS = new Set(["padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "backgroundOverlayOpacity", "backgroundOverlayColor", "border", "borderWidth", "borderStyle", "borderColor", "borderRadius", "borderLeft", "gap", "width", "height", "minWidth", "maxWidth", "minHeight", "maxHeight", "display", "flex", "flexDirection", "flexWrap", "alignItems", "justifyContent", "position", "top", "right", "bottom", "left", "zIndex", "clipPath", "overflow", "boxShadow", "outline", "outlineOffset", "transform", "columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset"]);

/** Per-column style arrays stored on the columns layout block. */
export var COLUMN_STYLE_ARRAY_KEYS = ["columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents"];
export function ensureColumnStyleArray(style, key, count) {
  return Array.from({
    length: count
  }, function (_, i) {
    var existing = Array.isArray(style === null || style === void 0 ? void 0 : style[key]) ? style[key][i] : "";
    return existing || "";
  });
}
export function getColumnStyleValue(style, key, index) {
  if (!Array.isArray(style === null || style === void 0 ? void 0 : style[key])) return "";
  return style[key][index] || "";
}
export function mapColumnStyleArrays(style, mapper) {
  var next = _objectSpread({}, style || {});
  COLUMN_STYLE_ARRAY_KEYS.forEach(function (key) {
    var arr = Array.isArray(next[key]) ? _toConsumableArray(next[key]) : [];
    next[key] = mapper(arr, key);
  });
  return next;
}
export function resolveStyleMaxWidth() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100%";
  var maxWidth = style === null || style === void 0 ? void 0 : style.maxWidth;
  if (maxWidth !== undefined && maxWidth !== null && maxWidth !== "" && maxWidth !== "none") {
    return maxWidth;
  }
  return fallback;
}

/** True when style has shorthand or any per-side value for margin/padding. */
export function styleHasSpacing(style, property) {
  if (!style) return false;
  var shorthand = style[property];
  if (shorthand !== undefined && shorthand !== null && shorthand !== "") return true;
  return hasIndividualSpacing(style, property);
}
var BUTTON_DEFAULT_PADDING = "12px 28px";

/** Button padding — treat missing / zero shorthand as unset so preview & PDF stay comfortable. */
export function resolveButtonPadding(style) {
  if (hasIndividualSpacing(style, "padding")) {
    return null; // caller keeps per-side values from style
  }

  var pad = style === null || style === void 0 ? void 0 : style.padding;
  if (pad === undefined || pad === null || pad === "" || pad === "0" || pad === "0px") {
    return BUTTON_DEFAULT_PADDING;
  }
  return pad;
}

/** Default vertical margin for export wrappers — only when user has not set margin.
 *  Prefer empty fallback: document stack uses gap (matches canvas BlockList). */
export function defaultBlockMarginCss(style) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (styleHasSpacing(style, "margin")) return "";
  return fallback ? "margin: ".concat(fallback, ";") : "";
}

/** Pick only margin props for the outer selection wrapper (sibling spacing). */
export function pickMarginStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = {};
  if (hasIndividualSpacing(style, "margin")) {
    SPACING_SIDES.forEach(function (s) {
      var key = "margin".concat(s.key);
      if (style[key] !== undefined && style[key] !== null && style[key] !== "") {
        next[key] = style[key];
      }
    });
    return next;
  }
  if (style.margin !== undefined && style.margin !== null && style.margin !== "") {
    next.margin = style.margin;
  }
  return next;
}

/** Strip margin props so they are not double-applied on the inner shell. */
export function omitMarginFromStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = _objectSpread({}, style);
  delete next.margin;
  SPACING_SIDES.forEach(function (s) {
    delete next["margin".concat(s.key)];
  });
  return next;
}

/** Pick only padding props (shorthand or per-side). */
export function pickPaddingStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = {};
  if (hasIndividualSpacing(style, "padding")) {
    SPACING_SIDES.forEach(function (s) {
      var key = "padding".concat(s.key);
      if (style[key] !== undefined && style[key] !== null && style[key] !== "") {
        next[key] = style[key];
      }
    });
    return next;
  }
  if (style.padding !== undefined && style.padding !== null && style.padding !== "") {
    next.padding = style.padding;
  }
  return next;
}

/** Strip padding so it can be applied on each column shell instead of the outer row. */
export function omitPaddingFromStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = _objectSpread({}, style);
  delete next.padding;
  SPACING_SIDES.forEach(function (s) {
    delete next["padding".concat(s.key)];
  });
  return next;
}

/**
 * Column layouts: Style-tab padding/background/border stay on the outer row.
 * Content-tab width, padding, background, and flex apply only to each column shell.
 */
export function splitColumnLayoutStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = style || {},
    columnBackgrounds = _ref3.columnBackgrounds,
    columnWidths = _ref3.columnWidths,
    columnHeights = _ref3.columnHeights,
    columnPaddings = _ref3.columnPaddings,
    columnBorderStyles = _ref3.columnBorderStyles,
    columnBorderWidths = _ref3.columnBorderWidths,
    columnBorderColors = _ref3.columnBorderColors,
    columnBorderRadii = _ref3.columnBorderRadii,
    columnAlignItems = _ref3.columnAlignItems,
    columnJustifyContents = _ref3.columnJustifyContents,
    _overlayOpacity = _ref3.backgroundOverlayOpacity,
    _overlayColor = _ref3.backgroundOverlayColor,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _w = rest.width,
    _minW = rest.minWidth,
    _maxW = rest.maxWidth,
    outerStyle = _objectWithoutProperties(rest, _excluded2);
  return {
    columnBackgrounds: columnBackgrounds,
    columnWidths: columnWidths,
    columnHeights: columnHeights,
    columnPaddings: columnPaddings,
    columnBorderStyles: columnBorderStyles,
    columnBorderWidths: columnBorderWidths,
    columnBorderColors: columnBorderColors,
    columnBorderRadii: columnBorderRadii,
    columnAlignItems: columnAlignItems,
    columnJustifyContents: columnJustifyContents,
    paddingStyle: pickPaddingStyle(rest),
    // Keep height / minHeight / maxHeight on the section so background heroes
    // match the builder canvas in preview and PDF.
    outerStyle: outerStyle
  };
}
function resolveColumnPaddingStyle(style, columnIndex) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref4$isEmpty = _ref4.isEmpty,
    isEmpty = _ref4$isEmpty === void 0 ? false : _ref4$isEmpty;
  var colPad = getColumnStyleValue(style, "columnPaddings", columnIndex);
  if (colPad) return {
    padding: colPad
  };
  if (isEmpty) return {
    padding: "12px 10px"
  };
  return {};
}

/**
 * % height is ignored when the parent’s height is auto (canvas / document flow).
 * Map N% → Nvh so the Height control actually changes the column.
 */
export function resolveAppliedColumnHeight(height) {
  if (height === undefined || height === null) return "";
  var str = String(height).trim();
  if (!str || str === "auto" || str === "fit-content") return "";
  var pct = str.match(/^(-?[\d.]+)\s*%$/);
  if (pct) {
    var n = parseFloat(pct[1]);
    if (!Number.isNaN(n)) return "".concat(n, "vh");
  }
  return str;
}

/** fit-content / max-content / min-content — size to content, not a fixed length. */
export function isIntrinsicColumnWidth(width) {
  var w = String(width || "").trim().toLowerCase();
  return w === "fit-content" || w === "max-content" || w === "min-content";
}
function resolveColumnSizeStyle(style, columnIndex) {
  var width = getColumnStyleValue(style, "columnWidths", columnIndex);
  var height = resolveAppliedColumnHeight(getColumnStyleValue(style, "columnHeights", columnIndex));
  var size = {};
  var hasFixedWidth = Boolean(width && width !== "auto");
  var isIntrinsic = hasFixedWidth && isIntrinsicColumnWidth(width);
  if (isIntrinsic) {
    // Hug content. Do not use minWidth:0 + flex-shrink — that crushed fit-content
    // columns in the builder (wrapped "STRATEGY-LED…" / skinny feature rows) while
    // preview HTML sized to the text max-content.
    size.flexGrow = 0;
    size.flexShrink = 0;
    size.flexBasis = "auto";
    size.width = width;
    size.maxWidth = "100%";
    size.minWidth = "auto";
  } else if (hasFixedWidth) {
    var isPercent = String(width).includes("%");
    // Never lock min-width to the column size — gap, drop outlines, and
    // selection borders would overflow and wrap the last column down.
    size.flexGrow = isPercent ? 1 : 0;
    size.flexShrink = 1;
    size.flexBasis = isPercent ? "0%" : width;
    size.width = width;
    size.maxWidth = width;
    size.minWidth = 0;
  } else {
    size.flexGrow = 1;
    size.flexShrink = 1;
    size.flexBasis = "0%";
    size.minWidth = 0;
  }
  if (height) {
    size.minHeight = height;
    size.height = height;
    size.maxHeight = height;
    size.alignSelf = "flex-start";
  } else if (hasFixedWidth) {
    size.alignSelf = "stretch";
  }
  return size;
}

/** One-column: Content width should size the section (Style background follows it). */
export function getColumnLayoutOuterWidth(style, isSingleColumn) {
  if (!isSingleColumn) return "100%";
  var width = getColumnStyleValue(style, "columnWidths", 0);
  if (width && width !== "auto") return width;
  return "100%";
}

/** True when border-radius is meant to render a circle (needs equal width/height + clip). */
export function isCircularBorderRadius(style) {
  var _style$borderRadius;
  var raw = String((_style$borderRadius = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _style$borderRadius !== void 0 ? _style$borderRadius : "").trim().toLowerCase();
  if (!raw) return false;
  if (raw === "50%" || raw === "100%") return true;
  var parsed = parseFloat(raw);
  if (!Number.isFinite(parsed)) return false;
  // Large px/rem radii behave as a circle on a square box
  return parsed >= 999;
}

/**
 * For circular one-column sections (icon badge pattern), return the locked box size.
 * Preview uses columnWidths/columnHeights together with border-radius: 50%.
 */
export function getCircularColumnBoxSize(style) {
  if (!isCircularBorderRadius(style)) return "";
  var width = getColumnStyleValue(style, "columnWidths", 0);
  var height = getColumnStyleValue(style, "columnHeights", 0);
  if (width && width !== "auto") return width;
  if (height && height !== "auto") return height;
  if (style !== null && style !== void 0 && style.width && style.width !== "auto" && style.width !== "100%") return style.width;
  return "";
}

/** True when a nested block should inherit text color from its parent column layout. */
export function hasElementColorOverride(node) {
  var elementStyles = node === null || node === void 0 ? void 0 : node.elementStyles;
  if (!elementStyles || _typeof(elementStyles) !== "object") return false;
  return Object.values(elementStyles).some(function (part) {
    return (part === null || part === void 0 ? void 0 : part.color) != null && (part === null || part === void 0 ? void 0 : part.color) !== "";
  });
}
export function shouldInheritColumnTextColor(node, inheritTextColor) {
  var _node$style4;
  if (!inheritTextColor) return false;
  if (isColumnLayoutType(node === null || node === void 0 ? void 0 : node.type)) return false;
  if (node !== null && node !== void 0 && (_node$style4 = node.style) !== null && _node$style4 !== void 0 && _node$style4.useCustomTextColor) return false;
  if (hasElementColorOverride(node)) return false;
  return true;
}
export function omitInheritedColumnTextColor() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var node = arguments.length > 1 ? arguments[1] : undefined;
  var inheritTextColor = arguments.length > 2 ? arguments[2] : undefined;
  if (!shouldInheritColumnTextColor(node, inheritTextColor)) return style;
  var _color = style.color,
    rest = _objectWithoutProperties(style, _excluded3);
  return rest;
}
export function getNodeWithColumnTextColorInheritance(node, inheritTextColor) {
  if (!shouldInheritColumnTextColor(node, inheritTextColor)) return node;
  var _ref5 = node.style || {},
    _color = _ref5.color,
    restStyle = _objectWithoutProperties(_ref5, _excluded4);
  return _objectSpread(_objectSpread({}, node), {}, {
    style: restStyle
  });
}
export function resolveColumnBorderStyle(style, columnIndex) {
  var borderStyle = getColumnStyleValue(style, "columnBorderStyles", columnIndex);
  var borderWidth = getColumnStyleValue(style, "columnBorderWidths", columnIndex);
  var borderColor = getColumnStyleValue(style, "columnBorderColors", columnIndex) || "#cbd5e1";
  var borderRadius = resolveColumnBorderRadius(style, columnIndex);
  var res = {};
  if (borderRadius !== undefined && borderRadius !== null && borderRadius !== "") {
    res.borderRadius = borderRadius;
  }
  if (borderStyle && borderStyle !== "none") {
    var widthStr = borderWidth !== undefined && borderWidth !== null && borderWidth !== "" ? borderWidth : "1px";
    var parts = String(widthStr).trim().split(/\s+/).filter(Boolean);
    if (parts.length > 1) {
      var top = parts[0] || "0px";
      var right = parts[1] || top;
      var bottom = parts[2] || (parts.length === 2 ? top : "0px");
      var left = parts[3] || right;
      res.borderTop = "".concat(top, " ").concat(borderStyle, " ").concat(borderColor);
      res.borderRight = "".concat(right, " ").concat(borderStyle, " ").concat(borderColor);
      res.borderBottom = "".concat(bottom, " ").concat(borderStyle, " ").concat(borderColor);
      res.borderLeft = "".concat(left, " ").concat(borderStyle, " ").concat(borderColor);
    } else {
      res.border = "".concat(widthStr, " ").concat(borderStyle, " ").concat(borderColor);
    }
  } else if (borderStyle === "none") {
    res.border = "none";
  }
  return res;
}

/**
 * Per-column radius. Never invent 8px when unset — that made the 3rd feature column
 * look rounded in the builder while siblings (explicit 0px) and preview stayed square.
 * Order: columnBorderRadii[i] → section borderRadius → none.
 */
export function resolveColumnBorderRadius(style, columnIndex) {
  var colRadius = getColumnStyleValue(style, "columnBorderRadii", columnIndex);
  if (colRadius !== undefined && colRadius !== null && String(colRadius).trim() !== "") {
    return colRadius;
  }
  if ((style === null || style === void 0 ? void 0 : style.borderRadius) !== undefined && style.borderRadius !== null && style.borderRadius !== "") {
    return style.borderRadius;
  }
  return "";
}

/** Canvas/React style for one column shell (matches preview + PDF). */
export function getColumnShellStyle(style, columnIndex) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref6$isEmpty = _ref6.isEmpty,
    isEmpty = _ref6$isEmpty === void 0 ? false : _ref6$isEmpty;
  var columnBg = getColumnBackground(style, columnIndex);
  var alignItems = getColumnStyleValue(style, "columnAlignItems", columnIndex) || "stretch";
  var justifyContent = getColumnStyleValue(style, "columnJustifyContents", columnIndex) || "flex-start";
  var borderStyle = resolveColumnBorderStyle(style, columnIndex);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, resolveColumnSizeStyle(style, columnIndex)), {}, {
    boxSizing: "border-box",
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    alignItems: alignItems,
    justifyContent: justifyContent
  }, columnBg ? {
    background: columnBg
  } : {}), style !== null && style !== void 0 && style.color ? {
    color: style.color
  } : {}), resolveColumnPaddingStyle(style, columnIndex, {
    isEmpty: isEmpty
  })), borderStyle);
}

/** CSS string for one column shell (HTML preview + PDF). */
export function buildColumnShellCss(style, columnIndex) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref7$forPdf = _ref7.forPdf,
    forPdf = _ref7$forPdf === void 0 ? false : _ref7$forPdf,
    _ref7$columnCount = _ref7.columnCount,
    columnCount = _ref7$columnCount === void 0 ? 2 : _ref7$columnCount;
  var columnBg = getColumnBackground(style, columnIndex);
  var padStyle = resolveColumnPaddingStyle(style, columnIndex);
  var padCss = padStyle.padding !== undefined ? "padding: ".concat(padStyle.padding) : Object.entries(padStyle).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      key = _ref9[0],
      value = _ref9[1];
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    return "".concat(kebab, ": ").concat(value);
  }).join("; ");
  var width = getColumnStyleValue(style, "columnWidths", columnIndex);
  var height = resolveAppliedColumnHeight(getColumnStyleValue(style, "columnHeights", columnIndex));
  var widthCss = width && width !== "auto" ? isIntrinsicColumnWidth(width) ? "flex: 0 0 auto; width: ".concat(width, "; max-width: 100%; min-width: auto") : String(width).includes("%") ? "flex: 1 1 0%; width: ".concat(width, "; max-width: ").concat(width, "; min-width: 0") : "flex: 0 1 ".concat(width, "; width: ").concat(width, "; max-width: ").concat(width, "; min-width: 0") : "flex: 1 1 0%; min-width: 0; width: ".concat((100 / Math.max(columnCount, 1)).toFixed(2), "%");
  var heightCss = height ? "min-height: ".concat(height, "; height: ").concat(height, "; max-height: ").concat(height, "; align-self: flex-start") : "";
  var borderObj = resolveColumnBorderStyle(style, columnIndex);
  var bgVal = columnBg ? forPdf ? gradientToSolid(columnBg) : columnBg : "";
  var bgCss = bgVal ? "background: ".concat(bgVal, ";") : "";
  var radiusVal = borderObj.borderRadius || "";
  var radiusCss = radiusVal ? "border-radius: ".concat(radiusVal, ";") : "";
  var borderCss = Object.entries(borderObj).filter(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      k = _ref11[0],
      v = _ref11[1];
    return k !== "borderRadius" && v && v !== "none";
  }).map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      k = _ref13[0],
      v = _ref13[1];
    return "".concat(k.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    }), ": ").concat(v);
  }).join("; ");
  var colorCss = style !== null && style !== void 0 && style.color ? "color: ".concat(style.color) : "";
  var alignItems = getColumnStyleValue(style, "columnAlignItems", columnIndex) || "stretch";
  var justifyContent = getColumnStyleValue(style, "columnJustifyContents", columnIndex) || "flex-start";
  var parts = ["vertical-align: top", "box-sizing: border-box", "overflow: visible", "display: flex", "flex-direction: column", "align-items: ".concat(alignItems), "justify-content: ".concat(justifyContent), widthCss, heightCss, bgCss, radiusCss, borderCss, colorCss, padCss].filter(Boolean);
  return parts.join("; ");
}

/** Outer row CSS for column layouts — keeps border/background; size/padding are per-column. */
export function buildColumnLayoutOuterCss(style) {
  var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref14$forPdf = _ref14.forPdf,
    forPdf = _ref14$forPdf === void 0 ? false : _ref14$forPdf;
  var _splitColumnLayoutSty = splitColumnLayoutStyle(style || {}),
    outerStyle = _splitColumnLayoutSty.outerStyle;
  // splitColumnLayoutStyle strips overlay meta — reattach so export matches canvas tint
  var styleForResolve = _objectSpread(_objectSpread({}, outerStyle), {}, {
    backgroundOverlayOpacity: style === null || style === void 0 ? void 0 : style.backgroundOverlayOpacity,
    backgroundOverlayColor: style === null || style === void 0 ? void 0 : style.backgroundOverlayColor
  });
  var omit = new Set(["cursor", "transition", "display", "flex", "flexDirection", "flexWrap", "gap", "gridTemplateColumns", "columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "backgroundOverlayOpacity", "backgroundOverlayColor", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset", "fontFamily", "fontWeight",
  // Per-column width only — section height/minHeight/boxShadow stay on the outer row
  "width", "minWidth", "maxWidth"]);
  // Keep layered background-image in PDF HTML too (Chrome print supports gradient + url)
  var resolved = resolveBorderStyleProps(resolveStyleWithBackgroundOverlay(styleForResolve));
  // Preserve section height as-is (match canvas)
  var parts = Object.entries(resolved).filter(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 1),
      key = _ref16[0];
    return !omit.has(key);
  }).map(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
      key = _ref18[0],
      value = _ref18[1];
    if (value === undefined || value === null || value === "") return null;
    var val = value;
    if (key === "background" || key === "backgroundColor") {
      val = forPdf ? gradientToSolid(val) : val;
    } else if (forPdf && String(val).includes("gradient") && key !== "backgroundImage") {
      val = gradientToSolid(val);
    } else if (key === "backgroundImage" && typeof val === "string" && val.includes("url(")) {
      val = val.replace(/url\(\s*"([^"]*)"\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      }).replace(/url\(\s*'([^']*)'\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      });
    }
    if (val === undefined || val === null || val === "") return null;
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    return "".concat(kebab, ": ").concat(val);
  }).filter(Boolean);

  // Circle badge sections need clip + locked square so border-radius: 50% stays a circle
  var circleBox = getCircularColumnBoxSize(style);
  if (circleBox) {
    parts.push("overflow: hidden");
    parts.push("aspect-ratio: 1 / 1");
    parts.push("height: ".concat(circleBox));
    parts.push("min-height: ".concat(circleBox));
    parts.push("max-height: ".concat(circleBox));
    parts.push("min-width: ".concat(circleBox));
    parts.push("flex-shrink: 0");
  }
  return parts.join("; ");
}

/** Extra inline padding so negative letter-spacing glyphs are not clipped in preview. */
export function getNegativeLetterSpacingPad(letterSpacing) {
  if (letterSpacing === undefined || letterSpacing === null || letterSpacing === "") return 0;
  var value = parseFloat(letterSpacing);
  if (!Number.isFinite(value) || value >= 0) return 0;
  return Math.ceil(Math.abs(value) + 2);
}

/** Background fill keys — keep these on heading/text tags so fill is not lost to the shell. */
export var BACKGROUND_FILL_STYLE_KEYS = ["background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat"];
export function pickBackgroundFillStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fill = {};
  BACKGROUND_FILL_STYLE_KEYS.forEach(function (key) {
    var value = style === null || style === void 0 ? void 0 : style[key];
    if (value === undefined || value === null || value === "") return;
    // Default "transparent" shorthand must not wipe a real color or background-image
    if ((key === "background" || key === "backgroundColor") && (value === "transparent" || value === "none")) return;
    fill[key] = value;
  });
  return fill;
}
export function omitBlockLayoutStyles() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keepKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var keep = new Set(keepKeys);
  var next = _objectSpread({}, style);
  BLOCK_LAYOUT_STYLE_KEYS.forEach(function (key) {
    if (keep.has(key)) return;
    delete next[key];
  });
  return next;
}
export function buildElementRenderStyle(node, elementKey, fallbackFont, fallbackWeight) {
  var _node$elementStyles2, _ref19, _elementStyle$fontWei;
  var extra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var elementStyle = elementKey && node !== null && node !== void 0 && (_node$elementStyles2 = node.elementStyles) !== null && _node$elementStyles2 !== void 0 && _node$elementStyles2[elementKey] ? node.elementStyles[elementKey] : {};
  if (!elementStyle || Object.keys(elementStyle).length === 0) {
    return _objectSpread({}, extra);
  }
  var blockStyle = (node === null || node === void 0 ? void 0 : node.style) || {};
  var font = resolveNodeFontFamily(_objectSpread(_objectSpread({}, blockStyle), elementStyle), fallbackFont);
  var weight = resolveFontWeight(font, (_ref19 = (_elementStyle$fontWei = elementStyle.fontWeight) !== null && _elementStyle$fontWei !== void 0 ? _elementStyle$fontWei : blockStyle.fontWeight) !== null && _ref19 !== void 0 ? _ref19 : fallbackWeight);
  var style = _objectSpread({}, extra);
  if (elementStyle.fontFamily !== undefined || elementStyle.fontWeight !== undefined) {
    style.fontFamily = font;
    style.fontWeight = weight;
  }
  var overrideKeys = ["color", "fontSize", "textAlign", "textTransform", "lineHeight", "letterSpacing", "opacity", "background", "backgroundColor", "padding", "fontFamily", "fontWeight", "width", "height", "margin", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "marginTop", "marginRight", "marginBottom", "marginLeft"];
  overrideKeys.forEach(function (key) {
    if (elementStyle[key] !== undefined) {
      if (key === "fontFamily") {
        style.fontFamily = resolveNodeFontFamily(elementStyle, fallbackFont);
      } else if (key === "fontWeight") {
        style.fontWeight = resolveFontWeight(font, elementStyle.fontWeight);
      } else {
        style[key] = elementStyle[key];
      }
    }
  });
  if (elementStyle.borderStyle) {
    style.border = elementStyle.borderStyle === "none" ? "none" : "".concat(elementStyle.borderWidth || "1px", " ").concat(elementStyle.borderStyle, " ").concat(elementStyle.borderColor || "#cbd5e1");
  }
  return style;
}
export function buildMergedElementStyle(node, elementKey, treeFont) {
  var _node$elementStyles3, _elementStyle$fontWei2;
  var baseDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var blockStyle = (node === null || node === void 0 ? void 0 : node.style) || {};
  var elementStyle = elementKey && node !== null && node !== void 0 && (_node$elementStyles3 = node.elementStyles) !== null && _node$elementStyles3 !== void 0 && _node$elementStyles3[elementKey] ? node.elementStyles[elementKey] : {};
  var font = resolveNodeFontFamily(_objectSpread(_objectSpread({}, blockStyle), elementStyle), treeFont);
  var weight = resolveFontWeight(font, (_elementStyle$fontWei2 = elementStyle.fontWeight) !== null && _elementStyle$fontWei2 !== void 0 ? _elementStyle$fontWei2 : blockStyle.fontWeight);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseDefaults), blockStyle), elementStyle), {}, {
    fontFamily: font,
    fontWeight: weight
  });
}
export function buildElementPdfCss(node, elementKey, treeFont) {
  var baseDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var merged = buildMergedElementStyle(node, elementKey, treeFont, baseDefaults);
  return buildPdfFontStyle(merged, treeFont, ["textAlign"]);
}
export function buildElementExportCss(node, elementKey, treeFont) {
  var baseDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var merged = buildMergedElementStyle(node, elementKey, treeFont, baseDefaults);
  return buildExportStyleCss(merged, treeFont);
}

/** CSS string of element-only overrides (elementStyles[key]) — empty when the element has no overrides. */
export function buildElementOverrideCss(node, elementKey, treeFont) {
  var _node$style5;
  var _ref20 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref20$omitLayout = _ref20.omitLayout,
    omitLayout = _ref20$omitLayout === void 0 ? false : _ref20$omitLayout;
  var style = buildElementRenderStyle(node, elementKey, resolveNodeFontFamily(node === null || node === void 0 ? void 0 : node.style, treeFont), node === null || node === void 0 || (_node$style5 = node.style) === null || _node$style5 === void 0 ? void 0 : _node$style5.fontWeight);
  if (omitLayout) {
    style = omitBlockLayoutStyles(style);
  }
  var css = Object.entries(style).filter(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 2),
      value = _ref22[1];
    return value !== undefined && value !== null && value !== "";
  }).map(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
      key = _ref24[0],
      value = _ref24[1];
    return "".concat(key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    }), ": ").concat(value);
  }).join("; ");
  return css ? css + ";" : "";
}
export function buildTableCellPdfCss(node, elementKey, treeFont) {
  var _node$elementStyles4, _elementStyle$fontWei3, _elementStyle$color, _elementStyle$fontSiz, _elementStyle$lineHei, _elementStyle$letterS, _elementStyle$opacity;
  var isHeader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var elementStyle = elementKey && node !== null && node !== void 0 && (_node$elementStyles4 = node.elementStyles) !== null && _node$elementStyles4 !== void 0 && _node$elementStyles4[elementKey] ? node.elementStyles[elementKey] : {};
  var blockStyle = (node === null || node === void 0 ? void 0 : node.style) || {};
  var font = resolveNodeFontFamily(_objectSpread(_objectSpread({}, blockStyle), elementStyle), treeFont);
  var weight = resolveFontWeight(font, (_elementStyle$fontWei3 = elementStyle.fontWeight) !== null && _elementStyle$fontWei3 !== void 0 ? _elementStyle$fontWei3 : blockStyle.fontWeight);
  var merged = _objectSpread(_objectSpread({}, isHeader ? {
    background: "#f8fafc",
    textAlign: "left"
  } : {}), {}, {
    fontFamily: font,
    fontWeight: weight,
    color: (_elementStyle$color = elementStyle.color) !== null && _elementStyle$color !== void 0 ? _elementStyle$color : blockStyle.color,
    fontSize: (_elementStyle$fontSiz = elementStyle.fontSize) !== null && _elementStyle$fontSiz !== void 0 ? _elementStyle$fontSiz : blockStyle.fontSize,
    lineHeight: (_elementStyle$lineHei = elementStyle.lineHeight) !== null && _elementStyle$lineHei !== void 0 ? _elementStyle$lineHei : blockStyle.lineHeight,
    letterSpacing: (_elementStyle$letterS = elementStyle.letterSpacing) !== null && _elementStyle$letterS !== void 0 ? _elementStyle$letterS : blockStyle.letterSpacing,
    opacity: (_elementStyle$opacity = elementStyle.opacity) !== null && _elementStyle$opacity !== void 0 ? _elementStyle$opacity : blockStyle.opacity
  }, elementStyle);
  var align = merged.textAlign || (isHeader ? "left" : "left");
  var styleStr = buildPdfStyleStr(merged, ["textAlign", "fontFamily", "fontWeight"]);
  var bg = merged.background ? "background: ".concat(gradientToSolid(merged.background) || merged.background, ";") : isHeader && !elementStyle.background ? "background: #f8fafc;" : "";
  return "".concat(styleStr, "; font-family: ").concat(font, "; font-weight: ").concat(weight, "; text-align: ").concat(align, "; ").concat(bg, " -webkit-print-color-adjust: exact; print-color-adjust: exact; ").concat(TABLE_CELL_WRAP_CSS).replace(/\s+/g, " ").trim();
}
export function buildTableCellExportCss(node, elementKey, treeFont) {
  var _node$elementStyles5, _elementStyle$fontWei4, _elementStyle$color2, _elementStyle$fontSiz2, _elementStyle$padding, _ref25, _elementStyle$backgro;
  var isHeader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var elementStyle = elementKey && node !== null && node !== void 0 && (_node$elementStyles5 = node.elementStyles) !== null && _node$elementStyles5 !== void 0 && _node$elementStyles5[elementKey] ? node.elementStyles[elementKey] : {};
  var blockStyle = (node === null || node === void 0 ? void 0 : node.style) || {};
  var font = resolveNodeFontFamily(_objectSpread(_objectSpread({}, blockStyle), elementStyle), treeFont);
  var weight = resolveFontWeight(font, (_elementStyle$fontWei4 = elementStyle.fontWeight) !== null && _elementStyle$fontWei4 !== void 0 ? _elementStyle$fontWei4 : blockStyle.fontWeight);
  var tableBorderStyle = blockStyle.tableBorderStyle || "solid";
  var tableBorderWidth = blockStyle.tableBorderWidth !== undefined ? blockStyle.tableBorderWidth : "1px";
  var tableBorderColor = blockStyle.tableBorderColor || "#e2e8f0";
  var defaultCellBorder = tableBorderStyle === "none" || tableBorderWidth === "0px" || tableBorderWidth === 0 || tableBorderWidth === "0" ? "none" : "".concat(tableBorderWidth, " ").concat(tableBorderStyle, " ").concat(tableBorderColor);
  var headerBg = blockStyle.headerBackground || "#f8fafc";
  var headerColor = blockStyle.headerColor;
  var rowBg = blockStyle.rowBackground;
  var stripedRows = Boolean(blockStyle.stripedRows);
  var stripedRowBg = blockStyle.stripedRowBackground || "#f8fafc";
  var cellPadding = blockStyle.cellPadding || "10px";
  var defaultBg = isHeader ? headerBg : rowBg || "";
  if (!isHeader && stripedRows && elementKey.startsWith("cell_")) {
    var _parts = elementKey.split("_");
    var rI = parseInt(_parts[1], 10);
    if (rI % 2 === 1) {
      defaultBg = stripedRowBg;
    }
  }
  var elementBorder = elementStyle.border || (elementStyle.borderStyle ? elementStyle.borderStyle === "none" ? "none" : "".concat(elementStyle.borderWidth || "1px", " ").concat(elementStyle.borderStyle, " ").concat(elementStyle.borderColor || "#cbd5e1") : undefined);
  var topBorderW = getShorthandSideLength(tableBorderWidth, "Top", 1, "px").value;
  var rightBorderW = getShorthandSideLength(tableBorderWidth, "Right", 1, "px").value;
  var bottomBorderW = getShorthandSideLength(tableBorderWidth, "Bottom", 1, "px").value;
  var leftBorderW = getShorthandSideLength(tableBorderWidth, "Left", 1, "px").value;
  var isNoneStyle = tableBorderStyle === "none";
  var cellBorderTop = isNoneStyle || topBorderW <= 0 ? "none" : "".concat(topBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
  var cellBorderRight = isNoneStyle || rightBorderW <= 0 ? "none" : "".concat(rightBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
  var cellBorderBottom = isNoneStyle || bottomBorderW <= 0 ? "none" : "".concat(bottomBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
  var cellBorderLeft = isNoneStyle || leftBorderW <= 0 ? "none" : "".concat(leftBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
  var merged = _objectSpread({
    fontFamily: font,
    fontWeight: weight,
    color: (_elementStyle$color2 = elementStyle.color) !== null && _elementStyle$color2 !== void 0 ? _elementStyle$color2 : isHeader && headerColor ? headerColor : blockStyle.color,
    fontSize: (_elementStyle$fontSiz2 = elementStyle.fontSize) !== null && _elementStyle$fontSiz2 !== void 0 ? _elementStyle$fontSiz2 : blockStyle.fontSize,
    padding: (_elementStyle$padding = elementStyle.padding) !== null && _elementStyle$padding !== void 0 ? _elementStyle$padding : cellPadding,
    background: (_ref25 = (_elementStyle$backgro = elementStyle.background) !== null && _elementStyle$backgro !== void 0 ? _elementStyle$backgro : elementStyle.backgroundColor) !== null && _ref25 !== void 0 ? _ref25 : defaultBg
  }, elementStyle);
  var align = merged.textAlign || "left";
  var parts = ["font-family: ".concat(font), "font-weight: ".concat(weight), "text-align: ".concat(align), "vertical-align: top", "padding: ".concat(merged.padding || cellPadding)];
  if (elementBorder) {
    parts.push(elementBorder !== "none" ? "border: ".concat(elementBorder) : "border: none");
  } else if (cellBorderTop === cellBorderRight && cellBorderRight === cellBorderBottom && cellBorderBottom === cellBorderLeft) {
    parts.push(cellBorderTop !== "none" ? "border: ".concat(cellBorderTop) : "border: none");
  } else {
    parts.push("border-top: ".concat(elementStyle.borderTop || cellBorderTop));
    parts.push("border-right: ".concat(elementStyle.borderRight || cellBorderRight));
    parts.push("border-bottom: ".concat(elementStyle.borderBottom || cellBorderBottom));
    parts.push("border-left: ".concat(elementStyle.borderLeft || cellBorderLeft));
  }
  if (merged.background) {
    parts.push("background: ".concat(merged.background));
  }
  if (merged.color) parts.push("color: ".concat(merged.color));
  if (merged.fontSize) parts.push("font-size: ".concat(merged.fontSize));
  if (merged.lineHeight) parts.push("line-height: ".concat(merged.lineHeight));
  if (merged.letterSpacing) parts.push("letter-spacing: ".concat(merged.letterSpacing));
  if (merged.textTransform && merged.textTransform !== "none") {
    parts.push("text-transform: ".concat(merged.textTransform));
  }
  if (merged.opacity !== undefined) parts.push("opacity: ".concat(merged.opacity));
  return "".concat(parts.join("; "), "; ").concat(TABLE_CELL_WRAP_CSS);
}
export function collectTreeFontFamilies(tree) {
  var fonts = new Set();
  var walk = function walk(nodes) {
    (nodes || []).forEach(function (node) {
      var _node$style6;
      if ((_node$style6 = node.style) !== null && _node$style6 !== void 0 && _node$style6.fontFamily) fonts.add(node.style.fontFamily);
      if (node.elementStyles) {
        Object.values(node.elementStyles).forEach(function (style) {
          if (style !== null && style !== void 0 && style.fontFamily) fonts.add(style.fontFamily);
        });
      }
      if (isNestedColumnContent(node.content)) {
        node.content.columns.forEach(function (col) {
          return walk(col);
        });
      }
    });
  };
  walk(tree);
  return fonts;
}
var SYSTEM_FONT_NAMES = new Set(["Georgia", "Times New Roman", "Courier New", "Arial", "Verdana", "Trebuchet MS", "sans-serif", "serif", "monospace", "cursive", "fantasy", "system-ui"]);

/** Extract quoted family name from a CSS font-family value like `'DM Sans', sans-serif`. */
export function extractFontFamilyName(fontVal) {
  if (!fontVal) return null;
  var quoted = String(fontVal).match(/['"]([^'"]+)['"]/);
  if (quoted) return quoted[1].trim();
  var first = String(fontVal).split(",")[0].trim().replace(/['"]/g, "");
  return first || null;
}
export function isSystemFontName(fontName) {
  return !fontName || SYSTEM_FONT_NAMES.has(fontName);
}

/** Inject a Google Fonts stylesheet for one family (idempotent). */
export function ensureGoogleFontLoaded(fontValOrName) {
  if (typeof document === "undefined") return;
  var fontName = extractFontFamilyName(fontValOrName) || String(fontValOrName || "").trim();
  if (isSystemFontName(fontName)) return;
  var linkId = "gfont-".concat(fontName.replace(/\s+/g, "-").toLowerCase());
  if (document.getElementById(linkId)) return;
  var link = document.createElement("link");
  link.id = linkId;
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=".concat(encodeURIComponent(fontName), ":wght@300;400;500;600;700;800&display=swap");
  document.head.appendChild(link);
}
export function buildGoogleFontLinksHtml(treeFont, tree) {
  var uniqueFonts = collectTreeFontFamilies(tree);
  uniqueFonts.add(treeFont);
  var googleFontsToLoad = [];
  uniqueFonts.forEach(function (fontVal) {
    var name = extractFontFamilyName(fontVal);
    if (name && !isSystemFontName(name)) {
      googleFontsToLoad.push(name.replace(/\s+/g, "+"));
    }
  });
  if (!googleFontsToLoad.length) return "";

  // Same weights as canvas (`ensureGoogleFontLoaded`) so 500/600/700 match the editor.
  var familiesStr = _toConsumableArray(new Set(googleFontsToLoad)).map(function (name) {
    return "".concat(name, ":wght@300;400;500;600;700;800");
  }).join("&family=");
  return "<link rel=\"preconnect\" href=\"https://fonts.googleapis.com\">\n<link rel=\"preconnect\" href=\"https://fonts.gstatic.com\" crossorigin>\n<link href=\"https://fonts.googleapis.com/css2?family=".concat(familiesStr, "&display=swap\" rel=\"stylesheet\">\n");
}
export function pdfFontCss(style, fallback) {
  return "font-family: ".concat(resolveNodeFontFamily(style, fallback), ";");
}
export function pdfTextWeight(style, fallback) {
  var fontFamily = resolveNodeFontFamily(style, fallback);
  return resolveFontWeight(fontFamily, style === null || style === void 0 ? void 0 : style.fontWeight);
}
export function buildExportStyleCss(style, treeFont) {
  var extraOmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$skipOverflow = options.skipOverflowVisible,
    skipOverflowVisible = _options$skipOverflow === void 0 ? false : _options$skipOverflow,
    _options$keepHeight = options.keepHeight,
    keepHeight = _options$keepHeight === void 0 ? true : _options$keepHeight;
  var resolved = resolveBorderStyleProps(resolveStyleWithBackgroundOverlay(style || {}));
  var font = resolveNodeFontFamily(resolved, treeFont);
  var weight = resolveFontWeight(font, resolved === null || resolved === void 0 ? void 0 : resolved.fontWeight);
  var omit = new Set(["fontFamily", "fontWeight", "columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "backgroundOverlayOpacity", "backgroundOverlayColor", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset", "markerColor"].concat(_toConsumableArray(extraOmit)));
  var parts = ["font-family: ".concat(font), "font-weight: ".concat(weight)];

  // keepHeight (default true): export `height` as-is to match canvas.
  // Set keepHeight:false only when content must grow past a fixed frame.
  var rawHeight = resolved.height != null ? String(resolved.height).trim() : "";
  var useHeightAsMin = !keepHeight && rawHeight && !["auto", "fit-content", "100%"].includes(rawHeight.toLowerCase());
  if (useHeightAsMin) {
    omit.add("height");
  }
  // Preserve intentional overflow; only force visible when unset (and not clipping shapes)
  var hasUserOverflow = resolved.overflow !== undefined && resolved.overflow !== null && resolved.overflow !== "";
  if (resolved.clipPath || skipOverflowVisible || hasUserOverflow) {
    omit.add("overflow");
  }
  Object.entries(resolved).forEach(function (_ref26) {
    var _ref27 = _slicedToArray(_ref26, 2),
      key = _ref27[0],
      value = _ref27[1];
    if (omit.has(key) || value === undefined || value === null || value === "") return;
    // Don't emit background: transparent — the shorthand resets background-image in some browsers
    if (key === "background" && (value === "transparent" || value === "none")) return;
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    var val = value;
    // Keep url() single-quoted so style="..." attributes stay valid HTML
    if (key === "backgroundImage" && typeof val === "string" && val.includes("url(")) {
      val = val.replace(/url\(\s*"([^"]*)"\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      }).replace(/url\(\s*'([^']*)'\s*\)/g, function (_, u) {
        return formatCssUrl(u);
      });
    }
    parts.push("".concat(kebab, ": ").concat(val));
  });
  if (useHeightAsMin && (resolved.minHeight === undefined || resolved.minHeight === null || resolved.minHeight === "")) {
    parts.push("min-height: ".concat(rawHeight));
  }
  if (!resolved.clipPath && !skipOverflowVisible && !hasUserOverflow) {
    parts.push("overflow: visible");
  }
  if (!parts.some(function (part) {
    return part.startsWith("max-width:");
  })) {
    parts.push("max-width: 100%");
  }

  // Negative letter-spacing pulls glyphs outside the box — pad so preview/PDF don't clip
  var lsPad = getNegativeLetterSpacingPad(resolved.letterSpacing);
  if (lsPad > 0) {
    var hasPaddingShorthand = parts.some(function (part) {
      return part.startsWith("padding:");
    });
    var hasPadLeft = parts.some(function (part) {
      return part.startsWith("padding-left:");
    });
    var hasPadRight = parts.some(function (part) {
      return part.startsWith("padding-right:");
    });
    if (!hasPaddingShorthand && !hasPadLeft) parts.push("padding-left: ".concat(lsPad, "px"));
    if (!hasPaddingShorthand && !hasPadRight) parts.push("padding-right: ".concat(lsPad, "px"));
  }
  return parts.join("; ") + "; " + BLOCK_TEXT_WRAP_CSS;
}
export function exportFontOnly(style, treeFont) {
  var font = resolveNodeFontFamily(style, treeFont);
  var weight = resolveFontWeight(font, style === null || style === void 0 ? void 0 : style.fontWeight);
  return "font-family: ".concat(font, "; font-weight: ").concat(weight, "; ").concat(BLOCK_TEXT_WRAP_CSS);
}
export function buildPdfFontStyle(style, treeFont) {
  var extraOmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return "".concat(exportFontOnly(style, treeFont), " ").concat(buildPdfStyleStr(style, ["fontFamily", "fontWeight"].concat(_toConsumableArray(extraOmit)))).trim();
}
export function buildPdfWrapperStyle(style) {
  var extraOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return buildPdfStyleStr(style, extraOmit);
}
export function renderPdfFloatColumns(items, renderItem) {
  var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  if (!items.length) return "";
  var columnCount = Math.min(cols, items.length);
  var cellWidth = (100 / columnCount).toFixed(2);
  var html = "<table style=\"width: 100%; border-collapse: collapse; margin: 10px 0; table-layout: fixed;\">";
  for (var i = 0; i < items.length; i += columnCount) {
    html += "<tr style=\"page-break-inside: avoid;\">";
    for (var j = 0; j < columnCount; j++) {
      var idx = i + j;
      var leftPad = j === 0 ? "0" : "8px";
      var rightPad = j === columnCount - 1 ? "0" : "8px";
      html += "<td style=\"width: ".concat(cellWidth, "%; vertical-align: top; padding: 0 ").concat(rightPad, " 12px ").concat(leftPad, ";\">");
      if (idx < items.length) {
        html += renderItem(items[idx], idx);
      }
      html += "</td>";
    }
    html += "</tr>";
  }
  html += "</table>";
  return html;
}
export function gradientToSolid(value) {
  if (!value || !String(value).includes("gradient")) return value;
  var matches = String(value).match(/#([0-9a-fA-F]{3,8})/g);
  if (matches && matches.length) return matches[matches.length - 1];
  return "#312e81";
}
export function extractBackgroundImageUrl(style) {
  var bg = style === null || style === void 0 ? void 0 : style.backgroundImage;
  if (!bg || !String(bg).includes("url")) return null;
  var match = String(bg).match(/url\(["']?([^"')]+)["']?\)/);
  return match ? match[1] : null;
}
export function buildPdfStyleStr(style) {
  var omitKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!style) return "";
  var resolved = resolveBorderStyleProps(style);
  var omit = new Set([].concat(_toConsumableArray(PDF_SKIP_STYLE_PROPS), _toConsumableArray(omitKeys)));
  return Object.entries(resolved).filter(function (_ref28) {
    var _ref29 = _slicedToArray(_ref28, 1),
      key = _ref29[0];
    return !omit.has(key);
  }).map(function (_ref30) {
    var _ref31 = _slicedToArray(_ref30, 2),
      key = _ref31[0],
      value = _ref31[1];
    if (value === undefined || value === null || value === "") return null;
    var val = value;
    if (key === "background" || key === "backgroundColor") {
      val = gradientToSolid(val);
    }
    if (String(val).includes("gradient")) return null;
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    return "".concat(kebab, ": ").concat(val);
  }).filter(Boolean).join("; ");
}
export function pdfAlignFromStyle(style) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "left";
  return (style === null || style === void 0 ? void 0 : style.textAlign) || fallback;
}
export function buildPdfButtonHtml(node, treeFont) {
  var wrapperExtra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var merged = buildMergedElementStyle(node, "text", treeFont);
  var align = pdfAlignFromStyle(merged, "left");
  var bg = gradientToSolid(merged.background && !String(merged.background).includes("gradient") ? merged.background : merged.backgroundColor || "#101828");
  var resolvedPadding = resolveButtonPadding(merged);
  var btnStyle = buildPdfStyleStr(merged, ["textAlign", "background", "backgroundColor", "fontFamily", "fontWeight", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft"].concat(_toConsumableArray(resolvedPadding ? ["padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"] : [])));
  var radius = merged.borderRadius || "24px";
  var padding = resolvedPadding || merged.padding || BUTTON_DEFAULT_PADDING;
  var fontSize = merged.fontSize || "16px";
  var fontFamily = resolveNodeFontFamily(merged, treeFont);
  var fontWeight = resolveFontWeight(fontFamily, merged.fontWeight);
  return "<div class=\"pdf-block\" style=\"margin: 8px 0; text-align: ".concat(align, "; ").concat(wrapperExtra, "\">\n    <span style=\"display: inline-flex; align-items: center; justify-content: center; max-width: 100%; text-align: center; background: ").concat(bg, "; color: ").concat(merged.color || "#ffffff", "; font-family: ").concat(fontFamily, "; font-weight: ").concat(fontWeight, "; padding: ").concat(padding, "; border-radius: ").concat(radius, "; border: none; font-size: ").concat(fontSize, "; line-height: 1.4; box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; ").concat(btnStyle, " ").concat(BLOCK_TEXT_WRAP_CSS, "\">").concat(escapeHtml(node.content.text), "</span>\n  </div>");
}
export function getEmojiUrl(symbol) {
  if (!symbol) return null;
  if (symbol === "★" || symbol === "☆") return null;

  // Emoji regex matching emojis
  var emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|[\uD800-\uDFFF][\uD800-\uDFFF]?)/;
  if (!emojiRegex.test(symbol)) return null;

  // We get the hex representation of the emoji
  var codePoints = [];
  for (var i = 0; i < symbol.length; i++) {
    var codePoint = symbol.codePointAt(i);
    if (codePoint > 0xffff) {
      i++; // skip surrogate pair
    }
    // Skip variation selector-16 (fe0f) if present
    if (codePoint === 0xfe0f) continue;
    codePoints.push(codePoint.toString(16));
  }
  var hex = codePoints.join("-");
  return "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/".concat(hex, ".png");
}
export function buildBlockIconInnerHtml() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var size = content.size || "40px";
  var color = style.color || "#101828";
  var iconDef = content.iconName ? findBlockIcon(content.iconName) : null;
  if (iconDef) {
    var paths = (iconDef.paths || []).map(function (d) {
      return "<path d=\"".concat(d, "\"/>");
    }).join("");
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(size, "\" height=\"").concat(size, "\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"").concat(color, "\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:middle;\">").concat(paths, "</svg>");
  }
  var symbol = content.symbol || "★";
  var emojiUrl = getEmojiUrl(symbol);
  if (emojiUrl) {
    return "<img src=\"".concat(escapeHtml(emojiUrl), "\" alt=\"").concat(escapeHtml(symbol), "\" style=\"width:").concat(size, ";height:").concat(size, ";vertical-align:middle;display:inline-block;\" />");
  }
  return "<span style=\"font-size:".concat(size, ";line-height:1;color:").concat(color, ";display:inline-block;\">").concat(escapeHtml(symbol), "</span>");
}
export function generatePdfHtml(tree, activeFont) {
  var backgroundColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "#FFFFFF";
  var documentPadding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
  var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "auto";
  var backgroundImage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
  // Same renderer as preview / canvas export so PDF matches the builder.
  return generateHtml(tree, activeFont, backgroundColor, documentPadding, pageSize, backgroundImage);
}
function inlineStyleFromObject() {
  var styleObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(styleObj).map(function (_ref32) {
    var _ref33 = _slicedToArray(_ref32, 2),
      key = _ref33[0],
      value = _ref33[1];
    if (value === undefined || value === null || value === "") return null;
    var kebab = key.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    return "".concat(kebab, ": ").concat(value);
  }).filter(Boolean).join("; ");
}
function buildExportHtmlForNodes(nodes, treeFont) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var inheritTextColor = options.inheritTextColor;
  var html = "";
  (nodes || []).forEach(function (rawNode) {
    var node = getNodeWithColumnTextColorInheritance(rawNode, inheritTextColor);
    var nodeStart = html.length;
    var styleStr = buildExportStyleCss(node.style, treeFont);
    var fontOnly = exportFontOnly(node.style, treeFont);
    if (node.type === "heading") {
      var tag = node.content.tag || "h1";
      var mergedTextStyle = buildMergedElementStyle(node, "text", treeFont);
      var headingCss = buildElementExportCss(node, "text", treeFont);
      var maxWidth = resolveStyleMaxWidth(mergedTextStyle, "100%");
      // Defaults first; headingCss last so user margin/line-height/max-width win.
      // word-break:normal — never split letters mid-word (builder was showing "Castellano"/"s").
      html += "<".concat(tag, " style=\"margin: 0; line-height: 1.25; overflow: visible; width: 100%; max-width: ").concat(maxWidth, "; box-sizing: border-box; overflow-wrap: break-word; word-break: normal; white-space: pre-wrap; print-color-adjust: exact; -webkit-print-color-adjust: exact; ").concat(headingCss, "\">").concat(inlineMarkdownToHtml(node.content.text), "</").concat(tag, ">");
    } else if (node.type === "text") {
      var _mergedTextStyle = buildMergedElementStyle(node, "text", treeFont);
      var textCss = buildElementExportCss(node, "text", treeFont);
      var _maxWidth = resolveStyleMaxWidth(_mergedTextStyle, "100%");
      html += "<p style=\"margin: 0; line-height: 1.5; overflow: visible; width: 100%; max-width: ".concat(_maxWidth, "; box-sizing: border-box; overflow-wrap: break-word; word-break: normal; white-space: pre-wrap; print-color-adjust: exact; -webkit-print-color-adjust: exact; ").concat(textCss, "\">").concat(inlineMarkdownToHtml(node.content.text), "</p>");
    } else if (node.type === "button") {
      var _node$style7, _node$elementStyles6;
      var resolvedPadding = resolveButtonPadding(node.style);
      var styleForExport = resolvedPadding ? _objectSpread(_objectSpread({}, node.style), {}, {
        padding: resolvedPadding
      }) : _objectSpread({}, node.style || {});
      // Keep builder default pill radius when style omits it (PDF path already defaults to 24px)
      if ((styleForExport.borderRadius === undefined || styleForExport.borderRadius === null || styleForExport.borderRadius === "") && !hasIndividualRadius(styleForExport)) {
        styleForExport.borderRadius = "24px";
      }
      var btnCss = buildElementExportCss(_objectSpread(_objectSpread({}, node), {}, {
        style: styleForExport
      }), "text", treeFont);
      var radiusCss = buildBorderRadiusCss(styleForExport);
      var align = ((_node$style7 = node.style) === null || _node$style7 === void 0 ? void 0 : _node$style7.textAlign) || ((_node$elementStyles6 = node.elementStyles) === null || _node$elementStyles6 === void 0 || (_node$elementStyles6 = _node$elementStyles6.text) === null || _node$elementStyles6 === void 0 ? void 0 : _node$elementStyles6.textAlign) || "left";
      var btnOuterMargin = defaultBlockMarginCss(node.style, "8px 0");
      html += "<div style=\"text-align: ".concat(align, "; ").concat(btnOuterMargin, "\">\n        <a href=\"").concat(node.content.url || "#", "\" target=\"").concat(node.content.target || "_blank", "\" style=\"border: none; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; max-width: 100%; font-size: 1rem; text-decoration: none; box-sizing: border-box; ").concat(btnCss, " ").concat(radiusCss, "\">").concat(node.content.text, "</a>\n      </div>");
    } else if (node.type === "image") {
      var _node$style8, _node$style9, _node$style10, _node$style11, _node$style12, _node$style13, _node$style15, _node$style16, _node$style17, _node$style18, _node$style19, _node$style20, _node$style21, _node$style22, _node$style23, _node$style27;
      var _align = ((_node$style8 = node.style) === null || _node$style8 === void 0 ? void 0 : _node$style8.textAlign) || "left";
      var isCircle = ((_node$style9 = node.style) === null || _node$style9 === void 0 ? void 0 : _node$style9.imageShape) === "circle";
      var widthVal = ((_node$style10 = node.style) === null || _node$style10 === void 0 ? void 0 : _node$style10.width) || "100%";
      var _maxWidth2 = resolveStyleMaxWidth(node.style, "100%");
      var objectFit = ((_node$style11 = node.style) === null || _node$style11 === void 0 ? void 0 : _node$style11.objectFit) || (isCircle ? "cover" : "contain");
      var objectPosition = ((_node$style12 = node.style) === null || _node$style12 === void 0 ? void 0 : _node$style12.objectPosition) || "50% 50%";
      var _radiusCss = buildBorderRadiusCss(node.style, {
        circle: isCircle
      });
      var hasRadius = isCircle || !!_radiusCss;
      // Minimal wrapper styles only — never call buildExportStyleCss here
      // (it injects overflow:visible which cancels circle/radius clipping).
      // Padding must match canvas: % padding is relative to the parent width
      // (e.g. padding-top: 50% creates hero height behind a small logo).
      var padStyle = pickPaddingStyle(node.style);
      var padCss = Object.entries(padStyle).map(function (_ref34) {
        var _ref35 = _slicedToArray(_ref34, 2),
          key = _ref35[0],
          value = _ref35[1];
        if (value === undefined || value === null || value === "") return null;
        var kebab = key.replace(/[A-Z]/g, function (m) {
          return "-".concat(m.toLowerCase());
        });
        return "".concat(kebab, ": ").concat(value);
      }).filter(Boolean).join("; ");
      var wrapParts = ["display: inline-block", "width: ".concat(widthVal), "max-width: ".concat(_maxWidth2), "box-sizing: border-box"];
      if (padCss) {
        wrapParts.push(padCss);
      }
      if ((_node$style13 = node.style) !== null && _node$style13 !== void 0 && _node$style13.position && node.style.position !== "static") {
        wrapParts.push("position: ".concat(node.style.position));
        ["top", "right", "bottom", "left", "zIndex"].forEach(function (key) {
          var _node$style14;
          var val = (_node$style14 = node.style) === null || _node$style14 === void 0 ? void 0 : _node$style14[key];
          if (val !== undefined && val !== null && val !== "") {
            var kebab = key === "zIndex" ? "z-index" : key;
            wrapParts.push("".concat(kebab, ": ").concat(val));
          }
        });
      }
      if ((_node$style15 = node.style) !== null && _node$style15 !== void 0 && _node$style15.transform) {
        wrapParts.push("transform: ".concat(node.style.transform));
        wrapParts.push("transform-origin: center");
      }
      if ((_node$style16 = node.style) !== null && _node$style16 !== void 0 && _node$style16.clipPath) {
        wrapParts.push("clip-path: ".concat(node.style.clipPath));
        wrapParts.push("overflow: hidden");
      }
      // Background / overlay on image wrapper (matches canvas containerStyle)
      var bgResolved = resolveStyleWithBackgroundOverlay(node.style || {});
      if (bgResolved.backgroundImage) {
        var bgImg = bgResolved.backgroundImage;
        if (typeof bgImg === "string" && bgImg.includes("url(")) {
          bgImg = bgImg.replace(/url\(\s*"([^"]*)"\s*\)/g, function (_, u) {
            return formatCssUrl(u);
          }).replace(/url\(\s*'([^']*)'\s*\)/g, function (_, u) {
            return formatCssUrl(u);
          });
        }
        wrapParts.push("background-image: ".concat(bgImg));
        wrapParts.push("background-size: ".concat(bgResolved.backgroundSize || "cover"));
        wrapParts.push("background-position: ".concat(bgResolved.backgroundPosition || "center"));
        wrapParts.push("background-repeat: ".concat(bgResolved.backgroundRepeat || "no-repeat"));
      }
      if ((_node$style17 = node.style) !== null && _node$style17 !== void 0 && _node$style17.background && node.style.background !== "transparent") {
        wrapParts.push("background: ".concat(node.style.background));
      } else if ((_node$style18 = node.style) !== null && _node$style18 !== void 0 && _node$style18.backgroundColor && node.style.backgroundColor !== "transparent") {
        wrapParts.push("background-color: ".concat(node.style.backgroundColor));
      }
      if (isCircle) {
        wrapParts.push("aspect-ratio: 1 / 1", "height: auto");
      }
      if (_radiusCss) {
        wrapParts.push(_radiusCss.replace(/;+\s*$/, ""));
      }
      if (hasRadius) {
        wrapParts.push("overflow: hidden");
      }
      if (((_node$style19 = node.style) === null || _node$style19 === void 0 ? void 0 : _node$style19.opacity) !== undefined && ((_node$style20 = node.style) === null || _node$style20 === void 0 ? void 0 : _node$style20.opacity) !== null && ((_node$style21 = node.style) === null || _node$style21 === void 0 ? void 0 : _node$style21.opacity) !== "") {
        wrapParts.push("opacity: ".concat(node.style.opacity));
      }
      if ((_node$style22 = node.style) !== null && _node$style22 !== void 0 && _node$style22.boxShadow) {
        wrapParts.push("box-shadow: ".concat(node.style.boxShadow));
      }
      if ((_node$style23 = node.style) !== null && _node$style23 !== void 0 && _node$style23.border && node.style.border !== "none") {
        wrapParts.push("border: ".concat(node.style.border));
      } else {
        var _node$style24, _node$style25, _node$style26;
        var bw = (_node$style24 = node.style) === null || _node$style24 === void 0 ? void 0 : _node$style24.borderWidth;
        var bs = (_node$style25 = node.style) === null || _node$style25 === void 0 ? void 0 : _node$style25.borderStyle;
        var bc = (_node$style26 = node.style) === null || _node$style26 === void 0 ? void 0 : _node$style26.borderColor;
        if (bw && bs && bs !== "none") {
          wrapParts.push("border: ".concat(bw, " ").concat(bs, " ").concat(bc || "#cbd5e1"));
        }
      }
      var imgRadiusCss = isCircle ? "border-radius: 50%;" : _radiusCss;
      var shapeClass = isCircle ? ' class="ws-img-shape-circle"' : hasRadius ? ' class="ws-img-shape-rounded"' : "";
      var imgTag = "<img src=\"".concat(node.content.src, "\" alt=\"").concat(escapeHtml(node.content.alt || "Image"), "\" style=\"display: block; width: 100%; height: ").concat(isCircle ? "100%" : ((_node$style27 = node.style) === null || _node$style27 === void 0 ? void 0 : _node$style27.height) || "auto", "; object-fit: ").concat(objectFit, "; object-position: ").concat(objectPosition, "; ").concat(imgRadiusCss, "\" />");
      var inner = "<div".concat(shapeClass, " style=\"").concat(wrapParts.join("; "), ";\">").concat(imgTag, "</div>");
      var imgOuterMargin = defaultBlockMarginCss(node.style);
      if (node.content.url) {
        html += "<div style=\"text-align: ".concat(_align, "; ").concat(imgOuterMargin, " max-width: 100%;\"><a href=\"").concat(node.content.url, "\" target=\"_blank\" style=\"display: inline-block; max-width: 100%;\">").concat(inner, "</a></div>");
      } else {
        html += "<div style=\"text-align: ".concat(_align, "; ").concat(imgOuterMargin, " max-width: 100%;\">").concat(inner, "</div>");
      }
    } else if (node.type === "card") {
      var _node$style28, _node$style29, _node$style30, _node$style31;
      var cardTitleCss = buildElementOverrideCss(node, "title", treeFont);
      var cardTextCss = buildElementOverrideCss(node, "text", treeFont);
      var cardGap = resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.card || 8, "px"));
      var borderW = ((_node$style28 = node.style) === null || _node$style28 === void 0 ? void 0 : _node$style28.borderWidth) || "1px";
      var borderS = ((_node$style29 = node.style) === null || _node$style29 === void 0 ? void 0 : _node$style29.borderStyle) || "solid";
      var borderC = ((_node$style30 = node.style) === null || _node$style30 === void 0 ? void 0 : _node$style30.borderColor) || "#e2e8f0";
      var shadowCss = (_node$style31 = node.style) !== null && _node$style31 !== void 0 && _node$style31.boxShadow ? "box-shadow: ".concat(node.style.boxShadow, ";") : "box-shadow: none;";
      html += "\n      <div style=\"display: flex; flex-direction: column; gap: ".concat(cardGap, "; border: ").concat(borderW, " ").concat(borderS, " ").concat(borderC, "; ").concat(shadowCss, " ").concat(styleStr, "\">\n          <h2 style=\"margin-top: 0; margin-bottom: 0; font-size: 1.25rem; ").concat(fontOnly, " ").concat(cardTitleCss, "\">").concat(node.content.title, "</h2>\n          <p style=\"margin-bottom: 0; opacity: 0.8; line-height: 1.5; white-space: pre-wrap; ").concat(fontOnly, " ").concat(cardTextCss, "\">").concat(node.content.text, "</p>\n      </div>\n      ");
    } else if (node.type === "page-break") {
      html += "<div style=\"page-break-after: always; break-after: page; height: 0;\"></div>";
    } else if (node.type === "divider") {
      var _node$style32, _node$style33, _node$style34, _node$style35, _node$style36, _node$style37, _node$style38, _node$style39, _node$style40, _node$style41;
      var lineWidth = !((_node$style32 = node.style) !== null && _node$style32 !== void 0 && _node$style32.borderWidth) || node.style.borderWidth === "0px" ? "1px" : node.style.borderWidth;
      var lineStyle = !((_node$style33 = node.style) !== null && _node$style33 !== void 0 && _node$style33.borderStyle) || node.style.borderStyle === "none" ? "solid" : node.style.borderStyle;
      var lineColor = ((_node$style34 = node.style) === null || _node$style34 === void 0 ? void 0 : _node$style34.borderColor) || "#1C252E";
      var spacingCss = buildSpacingCss(node.style, {
        marginFallback: "24px 0",
        paddingFallback: "0"
      });
      var extraParts = [];
      if (((_node$style35 = node.style) === null || _node$style35 === void 0 ? void 0 : _node$style35.opacity) !== undefined && ((_node$style36 = node.style) === null || _node$style36 === void 0 ? void 0 : _node$style36.opacity) !== null && ((_node$style37 = node.style) === null || _node$style37 === void 0 ? void 0 : _node$style37.opacity) !== "") {
        extraParts.push("opacity: ".concat(node.style.opacity));
      }
      if ((_node$style38 = node.style) !== null && _node$style38 !== void 0 && _node$style38.transform) extraParts.push("transform: ".concat(node.style.transform));
      var _widthVal = (_node$style39 = node.style) !== null && _node$style39 !== void 0 && _node$style39.width && node.style.width !== "auto" ? node.style.width : "100%";
      extraParts.push("width: ".concat(_widthVal));
      if ((_node$style40 = node.style) !== null && _node$style40 !== void 0 && _node$style40.maxWidth) extraParts.push("max-width: ".concat(node.style.maxWidth));
      if ((_node$style41 = node.style) !== null && _node$style41 !== void 0 && _node$style41.position && node.style.position !== "static") {
        extraParts.push("position: ".concat(node.style.position));
        ["top", "right", "bottom", "left", "zIndex"].forEach(function (key) {
          var _node$style42;
          var val = (_node$style42 = node.style) === null || _node$style42 === void 0 ? void 0 : _node$style42[key];
          if (val !== undefined && val !== null && val !== "") {
            var kebab = key === "zIndex" ? "z-index" : key;
            extraParts.push("".concat(kebab, ": ").concat(val));
          }
        });
      }
      var styleDeclarations = ["border: none", "border-top: ".concat(lineWidth, " ").concat(lineStyle, " ").concat(lineColor), "background: transparent", "box-sizing: border-box", "font-size: 0", "line-height: 0"];
      if (spacingCss) {
        styleDeclarations.push(spacingCss);
      }
      if (extraParts.length > 0) {
        styleDeclarations.push(extraParts.join("; "));
      }
      // Use a div (not <hr height:0>) so padding is preserved in Chromium PDF print
      html += "<div role=\"separator\" style=\"".concat(styleDeclarations.join("; "), ";\"></div>");
    } else if (node.type === "html") {
      html += "<div style=\"".concat(styleStr, "\">").concat(node.content.code, "</div>");
    } else if (node.type === "list") {
      var htmlListStyle = node.content.listStyle || "check";
      var listGap = resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.list || 6, "px"));
      // Block layout (padding/margin/background/gap) stays on <ul> only via styleStr
      var listHtml = "<ul style=\"list-style-type: none; display: flex; flex-direction: column; gap: ".concat(listGap, "; ").concat(styleStr, "\">");
      (node.content.items || []).forEach(function (item, i) {
        var _node$style43, _node$style44;
        // Element text overrides only — do not merge block padding/margin onto list items
        var itemCss = buildElementOverrideCss(node, "item_".concat(i), treeFont, {
          omitLayout: true
        });
        var markerColor = htmlListStyle === "check" ? "color: ".concat(((_node$style43 = node.style) === null || _node$style43 === void 0 ? void 0 : _node$style43.markerColor) || ((_node$style44 = node.style) === null || _node$style44 === void 0 ? void 0 : _node$style44.color) || "#10b981", ";") : "";
        listHtml += "<li style=\"padding: 0; margin: 0; background: transparent; display: flex; align-items: flex-start; gap: 8px;\">\n          <span style=\"".concat(markerColor, " flex-shrink: 0; font-weight: 700;\">").concat(escapeHtml(getListMarker(htmlListStyle, i)), "</span>\n          <span style=\"min-width: 0; flex: 1; ").concat(itemCss, " ").concat(BLOCK_TEXT_WRAP_CSS, "\">").concat(item, "</span>\n        </li>");
      });
      listHtml += "</ul>";
      html += listHtml;
    } else if (node.type === "spacer") {
      var _node$style45;
      html += "<div style=\"height: ".concat(((_node$style45 = node.style) === null || _node$style45 === void 0 ? void 0 : _node$style45.height) || "40px", "; ").concat(styleStr, "\"></div>");
    } else if (node.type === "social") {
      html += buildSocialExportHtml(node, styleStr);
    } else if (node.type === "table") {
      var colCount = getTableColumnCount(node.content);
      var tableWrapperCss = buildTableBlockWrapperCss(node.style);
      var tableOuterMargin = defaultBlockMarginCss(node.style);
      var tableHtml = "<div style=\"".concat(tableOuterMargin, " ").concat(tableWrapperCss, "\"><table style=\"").concat(getTableElementCss(colCount), "\"><thead><tr>");
      (node.content.headers || []).forEach(function (th, i) {
        var cellCss = buildTableCellExportCss(node, "header_".concat(i), treeFont, true);
        tableHtml += "<th style=\"".concat(cellCss, "\">").concat(th, "</th>");
      });
      tableHtml += "</tr></thead><tbody>";
      (node.content.rows || []).forEach(function (row, rI) {
        tableHtml += "<tr>";
        for (var cI = 0; cI < colCount; cI++) {
          var td = row && row[cI] !== undefined ? row[cI] : "";
          var cellCss = buildTableCellExportCss(node, "cell_".concat(rI, "_").concat(cI), treeFont, false);
          tableHtml += "<td style=\"".concat(cellCss, "\">").concat(escapeHtml(td), "</td>");
        }
        tableHtml += "</tr>";
      });
      tableHtml += "</tbody></table></div>";
      html += tableHtml;
    } else if (isColumnLayoutType(node.type)) {
      var colMargin = defaultBlockMarginCss(node.style);
      var outerCss = buildColumnLayoutOuterCss(node.style, {
        forPdf: false
      });
      var nestedCols = isNestedColumnContent(node.content) ? node.content.columns || [] : [];
      var _getColumnLayoutGapCo = getColumnLayoutGapConfig(node.type, node.style, nestedCols.length || (node.type === "one-column" ? 1 : node.type === "two-column" ? 2 : 3)),
        isSingleColumn = _getColumnLayoutGapCo.isSingleColumn,
        columnGap = _getColumnLayoutGapCo.columnGap,
        stackGap = _getColumnLayoutGapCo.stackGap;
      var overlay = buildInnerBorderOverlayHtml(node.style);
      html += "<div style=\"display: flex; flex-direction: row; flex-wrap: nowrap; align-items: stretch; gap: ".concat(columnGap, "; width: ").concat(getColumnLayoutOuterWidth(node.style, isSingleColumn), "; max-width: 100%; min-width: 0; ").concat(colMargin, " overflow: visible; position:relative; ").concat(outerCss, "\">").concat(overlay);
      if (isNestedColumnContent(node.content)) {
        (node.content.columns || []).forEach(function (colBlocks, i) {
          var _node$style46;
          var shellStyle = _objectSpread(_objectSpread({}, getColumnShellStyle(node.style, i)), stackGap && stackGap !== "0" && stackGap !== "0px" ? {
            gap: stackGap
          } : {});
          var shellCss = inlineStyleFromObject(shellStyle);
          var childrenHtml = buildExportHtmlForNodes(colBlocks || [], treeFont, {
            inheritTextColor: (_node$style46 = node.style) === null || _node$style46 === void 0 ? void 0 : _node$style46.color
          });
          html += "<div style=\"".concat(shellCss, "\">").concat(childrenHtml, "</div>");
        });
      } else if (node.type === "two-column") {
        var leftCss = buildElementOverrideCss(node, "leftText", treeFont);
        var rightCss = buildElementOverrideCss(node, "rightText", treeFont);
        var leftShell = Object.entries(getColumnShellStyle(node.style, 0)).map(function (_ref36) {
          var _ref37 = _slicedToArray(_ref36, 2),
            key = _ref37[0],
            value = _ref37[1];
          if (value === undefined || value === null || value === "") return null;
          var kebab = key.replace(/[A-Z]/g, function (m) {
            return "-" + m.toLowerCase();
          });
          return "".concat(kebab, ": ").concat(value);
        }).filter(Boolean).join("; ");
        var rightShell = Object.entries(getColumnShellStyle(node.style, 1)).map(function (_ref38) {
          var _ref39 = _slicedToArray(_ref38, 2),
            key = _ref39[0],
            value = _ref39[1];
          if (value === undefined || value === null || value === "") return null;
          var kebab = key.replace(/[A-Z]/g, function (m) {
            return "-" + m.toLowerCase();
          });
          return "".concat(kebab, ": ").concat(value);
        }).filter(Boolean).join("; ");
        html += "<div style=\"white-space: pre-wrap; ".concat(leftShell, "; ").concat(fontOnly, " ").concat(leftCss, "\">").concat(nl2br(node.content.leftText || ""), "</div>");
        html += "<div style=\"white-space: pre-wrap; ".concat(rightShell, "; ").concat(fontOnly, " ").concat(rightCss, "\">").concat(nl2br(node.content.rightText || ""), "</div>");
      } else if (node.type === "one-column") {
        var colCss = buildElementOverrideCss(node, "col1", treeFont);
        var shellCss = Object.entries(getColumnShellStyle(node.style, 0)).map(function (_ref40) {
          var _ref41 = _slicedToArray(_ref40, 2),
            key = _ref41[0],
            value = _ref41[1];
          if (value === undefined || value === null || value === "") return null;
          var kebab = key.replace(/[A-Z]/g, function (m) {
            return "-" + m.toLowerCase();
          });
          return "".concat(kebab, ": ").concat(value);
        }).filter(Boolean).join("; ");
        html += "<div style=\"white-space: pre-wrap; ".concat(shellCss, "; ").concat(fontOnly, " ").concat(colCss, "\">").concat(nl2br(node.content.col1 || ""), "</div>");
      } else {
        [node.content.col1, node.content.col2, node.content.col3].forEach(function (text, i) {
          var colKey = "col".concat(i + 1);
          var colCss = buildElementOverrideCss(node, colKey, treeFont);
          var shellCss = Object.entries(getColumnShellStyle(node.style, i)).map(function (_ref42) {
            var _ref43 = _slicedToArray(_ref42, 2),
              key = _ref43[0],
              value = _ref43[1];
            if (value === undefined || value === null || value === "") return null;
            var kebab = key.replace(/[A-Z]/g, function (m) {
              return "-" + m.toLowerCase();
            });
            return "".concat(kebab, ": ").concat(value);
          }).filter(Boolean).join("; ");
          html += "<div style=\"white-space: pre-wrap; ".concat(shellCss, "; ").concat(fontOnly, " ").concat(colCss, "\">").concat(nl2br(text || ""), "</div>");
        });
      }
      html += "</div>";
    } else if (node.type === "group") {
      var _node$content2;
      var groupGap = resolveBlockGap(node.style, "12px");
      html += "<div style=\"overflow: visible; display:flex; flex-direction:column; gap:".concat(groupGap, "; ").concat(styleStr, "\">").concat(buildExportHtmlForNodes(((_node$content2 = node.content) === null || _node$content2 === void 0 || (_node$content2 = _node$content2.columns) === null || _node$content2 === void 0 ? void 0 : _node$content2[0]) || [], treeFont), "</div>");
    } else if (node.type === "quote") {
      var _node$style47, _node$style48, _node$style49;
      var quoteTextCss = buildElementOverrideCss(node, "text", treeFont);
      var quoteAuthorCss = buildElementOverrideCss(node, "author", treeFont);
      var quoteRoleCss = buildElementOverrideCss(node, "role", treeFont);
      var quoteMargin = defaultBlockMarginCss(node.style);
      var quoteBorder = (_node$style47 = node.style) !== null && _node$style47 !== void 0 && _node$style47.borderLeft || (_node$style48 = node.style) !== null && _node$style48 !== void 0 && _node$style48.border || (_node$style49 = node.style) !== null && _node$style49 !== void 0 && _node$style49.borderWidth ? "" : "border-left: 4px solid #101828;";
      var quoteFontStyle = isSingleWeightFont(resolveNodeFontFamily(node.style, treeFont)) ? "normal" : "italic";
      html += "<blockquote style=\"".concat(quoteMargin, " ").concat(quoteBorder, " ").concat(styleStr, "\">\n        <p style=\"margin: 0 0 12px 0; font-size: 1.15rem; font-style: ").concat(quoteFontStyle, "; line-height: 1.6; white-space: pre-wrap; ").concat(fontOnly, " ").concat(quoteTextCss, "\">\"").concat(node.content.text || "", "\"</p>\n        <footer style=\"font-size: 0.9rem; opacity: 0.7; ").concat(fontOnly, "\"><span style=\"").concat(fontOnly, " ").concat(quoteAuthorCss, "\">").concat(node.content.author || "", "</span>").concat(node.content.role ? " \xB7 <span style=\"".concat(quoteRoleCss, "\">").concat(node.content.role, "</span>") : "", "</footer>\n      </blockquote>");
    } else if (node.type === "icon") {
      var _node$style50, _node$style51, _node$style52;
      var _align2 = ((_node$style50 = node.style) === null || _node$style50 === void 0 ? void 0 : _node$style50.textAlign) || "center";
      var iconMargin = defaultBlockMarginCss(node.style);
      var _inner = buildBlockIconInnerHtml(node.content, node.style);
      var explicitWidth = (_node$style51 = node.style) !== null && _node$style51 !== void 0 && _node$style51.width && node.style.width !== "auto" && node.style.width !== "100%" ? node.style.width : "";
      var _hasRadius = !!((_node$style52 = node.style) !== null && _node$style52 !== void 0 && _node$style52.borderRadius || hasIndividualRadius(node.style));
      var chromeCss = buildExportStyleCss(node.style, treeFont, ["textAlign", "width", "maxWidth", "minWidth", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "overflow"], {
        skipOverflowVisible: true
      });
      var sizeCss = explicitWidth ? "width: ".concat(explicitWidth, ";").concat(_hasRadius ? " height: ".concat(explicitWidth, ";") : "") : "";
      var clipCss = _hasRadius ? "overflow: hidden;" : "";
      html += "<div style=\"".concat(iconMargin, " text-align: ").concat(_align2, "; width: 100%; max-width: 100%;\">\n        <span style=\"display: inline-flex; align-items: center; justify-content: center; vertical-align: middle; line-height: 1; max-width: 100%; box-sizing: border-box; ").concat(chromeCss, " ").concat(sizeCss, " ").concat(clipCss, "\">").concat(_inner, "</span>\n      </div>");
    } else if (node.type === "gallery") {
      var cols = node.content.columns || 3;
      var galleryGap = resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.gallery, "px"));
      html += "<div style=\"".concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\"><div style=\"display: grid; grid-template-columns: repeat(").concat(cols, ", 1fr); gap: ").concat(galleryGap, ";\">");
      (node.content.images || []).forEach(function (img) {
        html += "<img src=\"".concat(img.src, "\" alt=\"").concat(img.alt || "", "\" style=\"width: 100%; aspect-ratio: 1 / 1; height: auto; object-fit: cover; border-radius: 8px; display: block;\" />");
      });
      html += "</div></div>";
    } else if (node.type === "cta") {
      var _node$style53;
      var ctaTitleCss = buildElementOverrideCss(node, "title", treeFont);
      var ctaSubtitleCss = buildElementOverrideCss(node, "subtitle", treeFont);
      var ctaButtonCss = buildElementOverrideCss(node, "buttonText", treeFont);
      var ctaGap = resolveBlockGap(node.style, "12px");
      var ctaAlign = ((_node$style53 = node.style) === null || _node$style53 === void 0 ? void 0 : _node$style53.textAlign) || "center";
      var ctaItems = ctaAlign === "left" ? "flex-start" : ctaAlign === "right" ? "flex-end" : "center";
      html += "<div style=\"".concat(defaultBlockMarginCss(node.style), " display: flex; flex-direction: column; gap: ").concat(ctaGap, "; text-align: ").concat(ctaAlign, "; align-items: ").concat(ctaItems, "; ").concat(styleStr, "\">\n        <h2 style=\"margin: 0; font-size: 1.75rem; ").concat(fontOnly, " ").concat(ctaTitleCss, "\">").concat(node.content.title || "", "</h2>\n        <p style=\"margin: 0; opacity: 0.85; ").concat(fontOnly, " ").concat(ctaSubtitleCss, "\">").concat(node.content.subtitle || "", "</p>\n        <a href=\"").concat(node.content.buttonUrl || "#", "\" target=\"").concat(node.content.buttonTarget || "_blank", "\" style=\"display: inline-block; padding: 10px 24px; border-radius: 20px; background: #ffffff; color: #1e1b4b; text-decoration: none; ").concat(fontOnly, " ").concat(ctaButtonCss, "\">").concat(node.content.buttonText || "Get Started", "</a>\n      </div>");
    } else if (node.type === "logos") {
      html += "<div style=\"".concat(defaultBlockMarginCss(node.style), " text-align: center; ").concat(styleStr, "\">");
      if (node.content.title) html += "<p style=\"margin: 0 0 16px 0; font-size: 13px; opacity: 0.7; text-transform: uppercase; letter-spacing: 0.05em; ".concat(fontOnly, "\">").concat(node.content.title, "</p>");
      html += "<div style=\"display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: ".concat(resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.logos, "px")), ";\">");
      (node.content.logos || []).forEach(function (logo) {
        html += "<img src=\"".concat(logo.src, "\" alt=\"").concat(logo.alt || "", "\" style=\"height: 36px; max-width: 120px; object-fit: contain; opacity: 0.7;\" />");
      });
      html += "</div></div>";
    } else if (node.type === "accordion") {
      html += "<div style=\"".concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\">");
      (node.content.items || []).forEach(function (item, i) {
        var titleCss = buildElementOverrideCss(node, "item_".concat(i, "_title"), treeFont);
        var bodyCss = buildElementOverrideCss(node, "item_".concat(i, "_body"), treeFont);
        html += "<details style=\"border-bottom: 1px solid #e2e8f0; padding: 8px 0;\" ".concat(i === (node.content.openIndex || 0) ? "open" : "", ">\n          <summary style=\"cursor: pointer; padding: 8px 0; ").concat(fontOnly, " ").concat(titleCss, "\">").concat(item.title || "", "</summary>\n          <p style=\"margin: 0; padding: 0 0 12px 0; opacity: 0.8; line-height: 1.6; white-space: pre-wrap; ").concat(fontOnly, " ").concat(bodyCss, "\">").concat(item.body || "", "</p>\n        </details>");
      });
      html += "</div>";
    } else if (node.type === "pricing") {
      html += "<div style=\"display: flex; gap: ".concat(resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.pricing, "px")), "; flex-wrap: wrap; ").concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\">");
      (node.content.plans || []).forEach(function (plan, i) {
        var nameCss = buildElementOverrideCss(node, "plan_".concat(i, "_name"), treeFont);
        var priceCss = buildElementOverrideCss(node, "plan_".concat(i, "_price"), treeFont);
        var periodCss = buildElementOverrideCss(node, "plan_".concat(i, "_period"), treeFont);
        var buttonCss = buildElementOverrideCss(node, "plan_".concat(i, "_buttonText"), treeFont);
        html += "<div style=\"flex: 1 1 180px; padding: 24px; border-radius: 12px; border: ".concat(plan.highlighted ? "2px solid #101828" : "1px solid #e2e8f0", "; background: ").concat(plan.highlighted ? "#f8fafc" : "#fff", "; text-align: center; ").concat(fontOnly, "\">\n          <h3 style=\"margin: 0 0 8px 0; ").concat(fontOnly, " ").concat(nameCss, "\">").concat(plan.name || "", "</h3>\n          <div style=\"font-size: 2rem; margin: 8px 0; ").concat(fontOnly, " ").concat(priceCss, "\">").concat(plan.price || "", "<span style=\"font-size: 14px; ").concat(periodCss, "\">").concat(plan.period || "", "</span></div>\n          <ul style=\"list-style: none; padding: 0; margin: 16px 0; text-align: left;\">");
        (plan.features || []).forEach(function (f, fi) {
          var featureCss = buildElementOverrideCss(node, "plan_".concat(i, "_feature_").concat(fi), treeFont);
          html += "<li style=\"padding: 4px 0; font-size: 14px; ".concat(fontOnly, " ").concat(featureCss, "\">\u2713 ").concat(f, "</li>");
        });
        html += "</ul><a href=\"#\" style=\"display: inline-block; padding: 8px 20px; border-radius: 20px; background: #101828; color: #fff; text-decoration: none; font-size: 13px; ".concat(fontOnly, " ").concat(buttonCss, "\">").concat(plan.buttonText || "Choose Plan", "</a></div>");
      });
      html += "</div>";
    } else if (node.type === "testimonials") {
      var _quoteFontStyle = isSingleWeightFont(resolveNodeFontFamily(node.style, treeFont)) ? "normal" : "italic";
      html += "<div style=\"display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: ".concat(resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.testimonials, "px")), "; ").concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\">");
      (node.content.items || []).forEach(function (item, i) {
        var _node$style54;
        var quoteCss = buildElementOverrideCss(node, "item_".concat(i, "_quote"), treeFont);
        var nameCss = buildElementOverrideCss(node, "item_".concat(i, "_name"), treeFont);
        var roleCss = buildElementOverrideCss(node, "item_".concat(i, "_role"), treeFont);
        html += "<div style=\"padding: 20px; border-radius: 12px; background: #f8fafc; border: 1px solid #e2e8f0; ".concat(fontOnly, "\">\n          <p style=\"margin: 0 0 16px 0; font-style: ").concat(_quoteFontStyle, "; line-height: 1.6; ").concat(fontOnly, " ").concat(quoteCss, "\">\"").concat(item.quote || "", "\"</p>\n          <div style=\"font-size: 14px; font-weight: ").concat(resolveFontWeight(resolveNodeFontFamily(node.style, treeFont), (_node$style54 = node.style) === null || _node$style54 === void 0 ? void 0 : _node$style54.fontWeight), "; ").concat(fontOnly, " ").concat(nameCss, "\">").concat(item.name || "", "</div>\n          <div style=\"font-size: 12px; opacity: 0.7; ").concat(fontOnly, " ").concat(roleCss, "\">").concat(item.role || "", "</div>\n        </div>");
      });
      html += "</div>";
    } else if (node.type === "text-banner") {
      var _node$style55, _node$style56, _node$style57;
      var bannerTitleCss = buildElementOverrideCss(node, "title", treeFont);
      var bannerTextCss = buildElementOverrideCss(node, "text", treeFont);
      var bannerLinkCss = buildElementOverrideCss(node, "linkText", treeFont);
      var bannerPad = styleHasSpacing(node.style, "padding") ? "" : "padding: 32px 28px;";
      var bannerRadius = (_node$style55 = node.style) !== null && _node$style55 !== void 0 && _node$style55.borderRadius || hasIndividualRadius(node.style) ? "" : "border-radius: 12px;";
      var bannerBg = (_node$style56 = node.style) !== null && _node$style56 !== void 0 && _node$style56.background || (_node$style57 = node.style) !== null && _node$style57 !== void 0 && _node$style57.backgroundColor ? "" : "background: #f1f5f9;";
      html += "<div style=\"".concat(defaultBlockMarginCss(node.style), " ").concat(bannerPad, " ").concat(bannerBg, " ").concat(bannerRadius, " display: flex; flex-direction: column; align-items: center; justify-content: center; gap: ").concat(resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS["text-banner"], "px")), "; text-align: center; ").concat(styleStr, "\">\n        ").concat(node.content.title ? "<div style=\"font-size: 1.125rem; font-weight: 700; color: #0f172a; ".concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(bannerTitleCss, "\">").concat(escapeHtml(node.content.title), "</div>") : "", "\n        <div style=\"font-size: 14px; font-weight: 400; color: #64748b; ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(bannerTextCss, "\">").concat(escapeHtml(node.content.text || ""), "</div>\n        ").concat(node.content.linkText ? "<a href=\"".concat(node.content.link || "#", "\" style=\"color: inherit; text-decoration: underline; font-size: 14px; ").concat(fontOnly, " ").concat(bannerLinkCss, "\">").concat(escapeHtml(node.content.linkText), " \u2192</a>") : "", "\n      </div>");
    } else if (node.type === "cover") {
      var _node$style58, _node$style59, _node$style60;
      var coverTitleCss = buildElementOverrideCss(node, "title", treeFont);
      var coverSubtitleCss = buildElementOverrideCss(node, "subtitle", treeFont);
      var coverDescCss = buildElementOverrideCss(node, "description", treeFont);
      var coverAuthorCss = buildElementOverrideCss(node, "author", treeFont);
      var coverDateCss = buildElementOverrideCss(node, "date", treeFont);
      var coverGap = resolveBlockGap(node.style, "12px");
      var coverPad = styleHasSpacing(node.style, "padding") ? "" : "padding: 50px 30px;";
      var coverMargin = defaultBlockMarginCss(node.style);
      var coverRadius = (_node$style58 = node.style) !== null && _node$style58 !== void 0 && _node$style58.borderRadius || hasIndividualRadius(node.style) ? "" : "border-radius: 12px;";
      var coverBg = (_node$style59 = node.style) !== null && _node$style59 !== void 0 && _node$style59.background ? "" : "background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%);";
      var coverColor = (_node$style60 = node.style) !== null && _node$style60 !== void 0 && _node$style60.color ? "" : "color: #ffffff;";
      html += "<div style=\"".concat(coverMargin, " ").concat(coverPad, " ").concat(coverBg, " ").concat(coverColor, " ").concat(coverRadius, " display: flex; flex-direction: column; gap: ").concat(coverGap, "; text-align: left; ").concat(styleStr, "\">\n        <h1 style=\"margin: 0; font-size: 32px; ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(coverTitleCss, "\">").concat(escapeHtml(node.content.title), "</h1>\n        <h3 style=\"margin: 0; font-size: 18px; font-weight: normal; opacity: 0.9; ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(coverSubtitleCss, "\">").concat(escapeHtml(node.content.subtitle), "</h3>\n        <p style=\"margin: 0; font-size: 14px; opacity: 0.8; line-height: 1.6; white-space: pre-wrap; ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(coverDescCss, "\">").concat(nl2br(node.content.description), "</p>\n        <div style=\"border-top: 1px solid rgba(255,255,255,0.2); padding-top: 15px; font-size: 12px; display: flex; justify-content: space-between; flex-wrap: wrap; gap: 10px; ").concat(fontOnly, "\">\n          <div><strong>Prepared By:</strong> <span style=\"").concat(coverAuthorCss, "\">").concat(escapeHtml(node.content.author), "</span></div>\n          <div><strong>Date:</strong> <span style=\"").concat(coverDateCss, "\">").concat(escapeHtml(node.content.date), "</span></div>\n        </div>\n      </div>");
    } else if (node.type === "signature") {
      var clientSig = node.content.clientSigned ? buildSignedSignatureHtml(node.content.clientSignature, "export") : "<div style=\"height: 50px; border: 2px dashed #cbd5e1; border-radius: 6px; margin-bottom: 10px; background: #f8fafc;\"></div>";
      var providerSig = node.content.providerSigned ? buildSignedSignatureHtml(node.content.providerSignature, "export") : "<div style=\"height: 50px; border: 2px dashed #cbd5e1; border-radius: 6px; margin-bottom: 10px; background: #f8fafc;\"></div>";
      html += "<div style=\"display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: ".concat(resolveBlockGap(node.style, "".concat(BLOCK_GAP_DEFAULTS.signature, "px")), "; ").concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\">\n        <div style=\"padding: 20px; border-radius: 8px; border: 1px solid #e2e8f0; background: #fff; color: #334155; ").concat(fontOnly, "\">\n          <div style=\"font-size: 11px; font-weight: bold; text-transform: uppercase; color: #94a3b8; margin-bottom: 12px;\">Client Representative</div>\n          ").concat(clientSig, "\n          <div style=\"font-size: 14px; font-weight: bold; color: #1e293b;\">").concat(escapeHtml(node.content.clientName), "</div>\n          <div style=\"font-size: 12px; color: #64748b;\">").concat(escapeHtml(node.content.clientTitle), "</div>\n          <div style=\"font-size: 11px; color: #94a3b8; margin-top: 4px;\">Date: ").concat(escapeHtml(node.content.clientDate), "</div>\n        </div>\n        <div style=\"padding: 20px; border-radius: 8px; border: 1px solid #e2e8f0; background: #fff; color: #334155; ").concat(fontOnly, "\">\n          <div style=\"font-size: 11px; font-weight: bold; text-transform: uppercase; color: #94a3b8; margin-bottom: 12px;\">Provider Representative</div>\n          ").concat(providerSig, "\n          <div style=\"font-size: 14px; font-weight: bold; color: #1e293b;\">").concat(escapeHtml(node.content.providerName), "</div>\n          <div style=\"font-size: 12px; color: #64748b;\">").concat(escapeHtml(node.content.providerTitle), "</div>\n          <div style=\"font-size: 11px; color: #94a3b8; margin-top: 4px;\">Date: ").concat(escapeHtml(node.content.providerDate), "</div>\n        </div>\n      </div>");
    } else if (node.type === "timeline") {
      var _node$content3, _node$content4, _node$content5;
      var timelineStyle = ((_node$content3 = node.content) === null || _node$content3 === void 0 ? void 0 : _node$content3.timelineStyle) || "numbered-circle";
      var accentColor = ((_node$content4 = node.content) === null || _node$content4 === void 0 ? void 0 : _node$content4.accentColor) || (timelineStyle === "classic-dot" ? "#101828" : "#c8a896");
      var showDate = ((_node$content5 = node.content) === null || _node$content5 === void 0 ? void 0 : _node$content5.showDate) !== undefined ? !!node.content.showDate : timelineStyle === "classic-dot";
      var _isCircle = timelineStyle === "numbered-circle";
      var isStep = timelineStyle === "numbered-step";
      var timelineItemsHtml = "";
      (node.content.items || []).forEach(function (item, i) {
        var _node$content6, _node$style61, _node$style62, _node$style63;
        var titleCss = buildElementOverrideCss(node, "item_".concat(i, "_title"), treeFont);
        var dateCss = buildElementOverrideCss(node, "item_".concat(i, "_date"), treeFont);
        var descCss = buildElementOverrideCss(node, "item_".concat(i, "_description"), treeFont);
        var isLast = i === node.content.items.length - 1;
        var markerHtml = "";
        var paddingTop = "0";
        var paddingBottom = isLast ? "4px" : "28px";
        var showNumbers = ((_node$content6 = node.content) === null || _node$content6 === void 0 ? void 0 : _node$content6.showNumber) !== false;
        var isNumCleared = item.number === "";
        var defaultStepNum = String(i + 1).padStart(2, "0");
        var defaultCircleNum = String(i + 1);
        var stepNumVal = item.number !== undefined ? item.number : defaultStepNum;
        var circleNumVal = item.number !== undefined ? item.number : defaultCircleNum;
        var shouldShowStepNum = showNumbers && !isNumCleared && Boolean(stepNumVal);
        var shouldShowCircleNum = showNumbers && !isNumCleared && Boolean(circleNumVal);
        var numberCss = buildElementOverrideCss(node, "item_".concat(i, "_number"), treeFont);
        if (_isCircle) {
          paddingTop = "4px";
          markerHtml = "<div style=\"display: flex; flex-direction: column; align-items: center; width: 32px; flex-shrink: 0;\">\n            <div style=\"width: 32px; height: 32px; border-radius: 50%; border: 2px solid ".concat(accentColor, "; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600; color: ").concat(accentColor, "; background: #ffffff; flex-shrink: 0; box-sizing: border-box; line-height: 1; margin: 0; ").concat(numberCss, "\">").concat(shouldShowCircleNum ? escapeHtml(circleNumVal) : "", "</div>\n            ").concat(!isLast ? "<div style=\"width: 2px; flex: 1; min-height: 28px; background: ".concat(accentColor, "; margin: 0;\"></div>") : "", "\n          </div>");
        } else if (isStep) {
          markerHtml = "<div style=\"display: flex; flex-direction: column; align-items: center; width: 20px; flex-shrink: 0;\">\n            <div style=\"width: 16px; height: 16px; border-radius: 50%; border: 2px solid ".concat(accentColor, "; background: #ffffff; flex-shrink: 0; box-sizing: border-box; margin: 0;\"></div>\n            ").concat(!isLast ? "<div style=\"width: 2px; flex: 1; min-height: 28px; background: ".concat(accentColor, "; margin: 0;\"></div>") : "", "\n          </div>");
        } else {
          paddingBottom = isLast ? "4px" : "20px";
          markerHtml = "<div style=\"display: flex; flex-direction: column; align-items: center; width: 16px; flex-shrink: 0;\">\n            <div style=\"width: 14px; height: 14px; border-radius: 50%; background: ".concat(accentColor, "; border: 2px solid ").concat(accentColor, "; flex-shrink: 0; box-sizing: border-box; margin: 0;\"></div>\n            ").concat(!isLast ? "<div style=\"width: 2px; flex: 1; min-height: 24px; background: ".concat(accentColor, "; margin: 0;\"></div>") : "", "\n          </div>");
        }
        var stepNumHtml = isStep && shouldShowStepNum ? "<span style=\"color: ".concat(accentColor, "; font-weight: 600; font-size: 13px; letter-spacing: 0.5px; margin-right: 8px; flex-shrink: 0; ").concat(numberCss, "\">").concat(escapeHtml(stepNumVal), "</span>") : "";
        var titleTransform = _isCircle ? "text-transform: uppercase; letter-spacing: 0.5px;" : "";
        var dateHtml = showDate && item.date ? "<span style=\"font-size: 12px; font-weight: bold; color: ".concat(((_node$style61 = node.style) === null || _node$style61 === void 0 ? void 0 : _node$style61.color) || "#101828", "; ").concat(dateCss, "\">").concat(escapeHtml(item.date), "</span>") : "";
        timelineItemsHtml += "<div style=\"display: flex; gap: ".concat(_isCircle ? "20px" : "16px", "; min-width: 0; margin: 0; padding: 0;\">\n          ").concat(markerHtml, "\n          <div style=\"flex: 1; min-width: 0; padding-top: ").concat(paddingTop, "; padding-bottom: ").concat(paddingBottom, ";\">\n            <div style=\"display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 8px;\">\n              <div style=\"display: flex; align-items: baseline; flex: 1; min-width: 0;\">\n                ").concat(stepNumHtml, "\n                <h4 style=\"margin: 0; font-size: ").concat(isStep ? "15px" : "14px", "; font-weight: 600; color: ").concat(((_node$style62 = node.style) === null || _node$style62 === void 0 ? void 0 : _node$style62.color) || "#1e293b", "; ").concat(titleTransform, " ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(titleCss, "\">").concat(escapeHtml(item.title), "</h4>\n              </div>\n              ").concat(dateHtml, "\n            </div>\n            <p style=\"margin: 6px 0 0 0; font-size: 13px; color: ").concat(((_node$style63 = node.style) === null || _node$style63 === void 0 ? void 0 : _node$style63.color) || "#475569", "; line-height: 1.6; white-space: pre-wrap; ").concat(fontOnly, " ").concat(BLOCK_TEXT_WRAP_CSS, " ").concat(descCss, "\">").concat(nl2br(item.description), "</p>\n          </div>\n        </div>");
      });
      html += "<div style=\"display: flex; flex-direction: column; gap: 0; ".concat(defaultBlockMarginCss(node.style), " ").concat(styleStr, "\">").concat(timelineItemsHtml, "</div>");
    }
    var nodeMarkup = html.slice(nodeStart);
    // Column layouts already inject the inner-border overlay on the outer row
    var wrappedMarkup = isColumnLayoutType(node.type) ? nodeMarkup : injectInnerBorderIntoHtmlMarkup(nodeMarkup, node.style);
    html = "".concat(html.slice(0, nodeStart), "<div data-builder-node=\"").concat(escapeHtml(node.id), "\">").concat(wrappedMarkup, "</div>");
  });
  return html;
}
function buildResponsiveCss(tree) {
  var rules = {
    tablet: [],
    mobile: []
  };
  var metadataKeys = new Set(["columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "backgroundOverlayOpacity", "backgroundOverlayColor", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset"]);
  var visualKeys = new Set(["background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "color", "fontFamily", "fontSize", "fontWeight", "lineHeight", "letterSpacing", "textAlign", "textTransform", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "border", "borderWidth", "borderStyle", "borderColor", "borderRadius", "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth", "boxShadow", "opacity", "transform", "clipPath", "objectFit", "objectPosition", "alignItems", "justifyContent", "gap", "outline", "outlineOffset", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset"]);
  var declarations = function declarations(style) {
    var onlyVisual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return Object.entries(resolveBorderStyleProps(resolveStyleWithBackgroundOverlay(style || {}))).filter(function (_ref44) {
      var _ref45 = _slicedToArray(_ref44, 2),
        key = _ref45[0],
        value = _ref45[1];
      return !metadataKeys.has(key) && (!onlyVisual || visualKeys.has(key)) && value !== undefined && value !== null && value !== "";
    }).map(function (_ref46) {
      var _ref47 = _slicedToArray(_ref46, 2),
        key = _ref47[0],
        value = _ref47[1];
      return "".concat(key.replace(/[A-Z]/g, function (_char) {
        return "-".concat(_char.toLowerCase());
      }), ":").concat(value, " !important");
    }).join(";");
  };
  var walk = function walk(nodes) {
    (nodes || []).forEach(function (node) {
      var _node$content7;
      ["tablet", "mobile"].forEach(function (viewport) {
        var _node$responsiveStyle;
        var style = (_node$responsiveStyle = node.responsiveStyles) === null || _node$responsiveStyle === void 0 ? void 0 : _node$responsiveStyle[viewport];
        if (!style) return;
        var selector = "[data-builder-node=\"".concat(node.id, "\"]");
        var wrapperCss = declarations(style);
        var visualCss = declarations(style, true);
        if (wrapperCss) rules[viewport].push("".concat(selector, "{").concat(wrapperCss, "}"));
        if (visualCss) rules[viewport].push("".concat(selector, ">:first-child{").concat(visualCss, "}"));
      });
      var columns = (_node$content7 = node.content) === null || _node$content7 === void 0 ? void 0 : _node$content7.columns;
      if (Array.isArray(columns) && columns.length > 0 && Array.isArray(columns[0])) {
        columns.forEach(walk);
      }
    });
  };
  walk(tree);
  if (!rules.tablet.length && !rules.mobile.length) return "";
  return "<style>\n    @media (min-width: 576px) and (max-width: 991px) { ".concat(rules.tablet.join("\n"), " }\n    @media (max-width: 575px) { ").concat(rules.mobile.join("\n"), " }\n  </style>");
}
export function generateHtml(tree, activeFont) {
  var backgroundColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "#FFFFFF";
  var documentPadding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
  var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "auto";
  var backgroundImage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
  var treeFont = activeFont || getTreeFontFamily(tree);
  var fontLinksHtml = buildGoogleFontLinksHtml(treeFont, tree);
  var headingResetCss = "<style>[data-builder-document] h1,[data-builder-document] h2,[data-builder-document] h3,[data-builder-document] h4,[data-builder-document] h5,[data-builder-document] h6{font-weight:inherit;}</style>";
  var documentBackground = backgroundColor || "#FFFFFF";
  var bgImageUrl = String(backgroundImage || "").trim();
  var bgImageCss = bgImageUrl ? "background-image: ".concat(formatCssUrl(bgImageUrl), "; background-size: cover; background-position: center; background-repeat: no-repeat;") : "";
  var pad = Math.max(0, parseInt(documentPadding, 10) || 0);
  var dimensions = {
    a4: {
      width: "210mm",
      minHeight: "297mm",
      printSize: "A4"
    },
    letter: {
      width: "8.5in",
      minHeight: "11in",
      printSize: "Letter"
    },
    legal: {
      width: "8.5in",
      minHeight: "14in",
      printSize: "Legal"
    }
  }[pageSize];
  // Auto / Web: exactly matches canvas desktopWidth (880px)
  var pageCss = dimensions ? "width: ".concat(dimensions.width, "; min-height: ").concat(dimensions.minHeight, "; max-width: 100%;") : "width: 100%; max-width: 880px; min-height: 100%;";
  var printCss = dimensions ? "<style>@page { size: ".concat(dimensions.printSize, "; margin: 0; }</style>") : "<style>@page { size: auto; margin: 0; }</style>";
  var responsiveCss = buildResponsiveCss(tree);
  var borderRadiusCss = pad === 0 ? "border-radius: 0;" : "border-radius: 12px;";

  // data-builder-document: stable root for PHP chrome; no forced gap (spacing comes from block margins)
  var html = fontLinksHtml + headingResetCss + printCss + responsiveCss + "\n  <div data-builder-document style=\"font-family: ".concat(treeFont, "; background-color: ").concat(documentBackground, "; ").concat(borderRadiusCss, " ").concat(bgImageCss, " ").concat(pageCss, " margin: 0 auto; padding: ").concat(pad, "px; box-sizing: border-box; overflow: visible; position: relative; box-shadow: 0 8px 30px rgba(15, 23, 42, 0.12); ").concat(BLOCK_TEXT_WRAP_CSS, "\">\n    <div data-builder-stack style=\"display: flex; flex-direction: column; width: 100%; min-width: 0; box-sizing: border-box;\">\n  ");
  html += buildExportHtmlForNodes(tree, treeFont);
  html += "</div></div>";
  return html;
}
export function parsePxValue(val) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (val === undefined || val === null || val === "") return fallback;
  var n = parseInt(String(val), 10);
  return Number.isNaN(n) ? fallback : n;
}
export function parseCssLength(val) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var fallbackUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "px";
  if (val === undefined || val === null || val === "") {
    return {
      value: fallback,
      unit: fallbackUnit
    };
  }
  var match = String(val).trim().match(/^(-?[\d.]+)\s*(px|%|em|rem|vh|vw)?$/i);
  if (!match) return {
    value: fallback,
    unit: fallbackUnit
  };
  var value = parseFloat(match[1]);
  var rawUnit = (match[2] || fallbackUnit).toLowerCase();
  var allowed = [].concat(_toConsumableArray(RADIUS_UNITS), ["vh", "vw"]);
  return {
    value: Number.isNaN(value) ? fallback : value,
    unit: allowed.includes(rawUnit) ? rawUnit : fallbackUnit
  };
}

/** Line-height: unitless multiplier (×) or absolute px/em/rem. */
export var LINE_HEIGHT_UNITS = ["×", "px", "em"];
export function parseLineHeight(val) {
  var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
  var fallbackUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "×";
  if (val === undefined || val === null || val === "") {
    return {
      value: fallbackValue,
      unit: fallbackUnit
    };
  }
  var str = String(val).trim().toLowerCase();
  if (str === "normal") {
    return {
      value: fallbackValue,
      unit: fallbackUnit
    };
  }
  var match = str.match(/^(-?[\d.]+)\s*(px|em|rem)?$/i);
  if (!match) return {
    value: fallbackValue,
    unit: fallbackUnit
  };
  var value = parseFloat(match[1]);
  if (Number.isNaN(value)) return {
    value: fallbackValue,
    unit: fallbackUnit
  };
  var unit = match[2] ? match[2].toLowerCase() : "×";
  return {
    value: value,
    unit: LINE_HEIGHT_UNITS.includes(unit) || unit === "rem" ? unit === "rem" ? "em" : unit : fallbackUnit
  };
}
export function formatLineHeight(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "×";
  var num = parseFloat(value);
  var safe = Number.isNaN(num) ? 1.5 : Math.max(0, num);
  if (!unit || unit === "×") {
    // Keep one decimal for multipliers when needed
    return Number.isInteger(safe) ? String(safe) : String(Math.round(safe * 100) / 100);
  }
  var u = unit === "rem" ? "em" : unit;
  return "".concat(unit === "px" ? Math.round(safe) : Math.round(safe * 100) / 100).concat(u);
}
export function formatCssLength(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "px";
  var _ref48 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref48$allowNegative = _ref48.allowNegative,
    allowNegative = _ref48$allowNegative === void 0 ? false : _ref48$allowNegative;
  if (SIZE_KEYWORD_UNITS.includes(unit)) return unit;
  var parsed = parseFloat(value) || 0;
  var num = allowNegative ? parsed : Math.max(0, parsed);
  var allowed = [].concat(_toConsumableArray(RADIUS_UNITS), ["vh", "vw"], _toConsumableArray(SPACING_UNITS));
  var u = allowed.includes(unit) ? unit : "px";
  return "".concat(num).concat(u);
}
export function parseSizeLength(val) {
  var fallbackUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
  if (val === undefined || val === null || val === "") {
    return {
      value: 0,
      unit: fallbackUnit,
      isKeyword: SIZE_KEYWORD_UNITS.includes(fallbackUnit)
    };
  }
  var str = String(val).trim().toLowerCase();
  if (SIZE_KEYWORD_UNITS.includes(str)) {
    return {
      value: 0,
      unit: str,
      isKeyword: true
    };
  }
  var parsed = parseCssLength(val, 0, "px");
  var unit = SIZE_UNITS.includes(parsed.unit) ? parsed.unit : "px";
  return {
    value: parsed.value,
    unit: unit,
    isKeyword: false
  };
}
export function getSizeLength(style, property) {
  var fallbackUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "auto";
  return parseSizeLength(style === null || style === void 0 ? void 0 : style[property], fallbackUnit);
}
export function getOffsetLength(style, sideKey) {
  return parseCssLength(style === null || style === void 0 ? void 0 : style[sideKey], 0, "px");
}

/** Convert the builder's safe inline formatting tokens into HTML. */
export function inlineMarkdownToHtml(text) {
  var escaped = escapeHtml(text !== null && text !== void 0 ? text : "");
  return escaped.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/__(.+?)__/g, "<u>$1</u>").replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>").replace(/\[color=(#[\da-fA-F]{3,8})\](.+?)\[\/color\]/g, '<span style="color:$1">$2</span>').replace(/\[bg=(#[\da-fA-F]{3,8})\](.+?)\[\/bg\]/g, '<span style="background-color:$1">$2</span>').replace(/\[size=([0-9.]+(?:px|em|rem|%))\](.+?)\[\/size\]/g, '<span style="font-size:$1">$2</span>').replace(/\n/g, "<br>");
}
export function hasInlineMarkdown(text) {
  return typeof text === "string" && /(\*\*.+?\*\*|__.+?__|\*[^*\n]+\*|\[color=#[\da-fA-F]{3,8}\].+?\[\/color\]|\[bg=#[\da-fA-F]{3,8}\].+?\[\/bg\]|\[size=[^\]]+\].+?\[\/size\])/.test(text);
}
var INLINE_WRAP_KEYS = new Set(["color", "background", "fontSize", "fontWeight"]);

/** Wrap a textarea selection with inline tokens so Style panel can target highlighted words. */
export function wrapInlineSelection(text, start, end, styleKey, value) {
  if (!INLINE_WRAP_KEYS.has(styleKey)) return null;
  var valueStr = String(text !== null && text !== void 0 ? text : "");
  var from = Math.max(0, Math.min(Number(start) || 0, Number(end) || 0));
  var to = Math.min(valueStr.length, Math.max(Number(start) || 0, Number(end) || 0));
  if (to <= from) return null;
  var selected = valueStr.slice(from, to);
  var unwrapThenWrap = function unwrapThenWrap(fullRe, open, close, skipWrap) {
    var inner = fullRe.test(selected) ? selected.replace(fullRe, "$1") : selected;
    if (skipWrap) return inner;
    return "".concat(open).concat(inner).concat(close);
  };
  var wrapped = selected;
  if (styleKey === "color") {
    var skip = !value || value === "transparent";
    wrapped = unwrapThenWrap(/^\[color=#[\da-fA-F]{3,8}\]([\s\S]*)\[\/color\]$/, "[color=".concat(value, "]"), "[/color]", skip);
  } else if (styleKey === "background") {
    var _skip = !value || value === "transparent";
    wrapped = unwrapThenWrap(/^\[bg=#[\da-fA-F]{3,8}\]([\s\S]*)\[\/bg\]$/, "[bg=".concat(value, "]"), "[/bg]", _skip);
  } else if (styleKey === "fontSize") {
    wrapped = unwrapThenWrap(/^\[size=[^\]]+\]([\s\S]*)\[\/size\]$/, "[size=".concat(value, "]"), "[/size]", !value);
  } else if (styleKey === "fontWeight") {
    var inner = selected.replace(/^\*\*([\s\S]*)\*\*$/, "$1");
    wrapped = parseInt(value, 10) >= 700 ? "**".concat(inner, "**") : inner;
  }
  return {
    text: valueStr.slice(0, from) + wrapped + valueStr.slice(to),
    start: from,
    end: from + wrapped.length
  };
}
export function parsePxFromShorthand(val, side) {
  var _parts$map$side;
  if (!val) return 0;
  var parts = String(val).trim().split(/\s+/).map(function (p) {
    return parsePxValue(p);
  });
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) {
    return side === "Top" || side === "Bottom" ? parts[0] : parts[1];
  }
  if (parts.length === 3) {
    if (side === "Top") return parts[0];
    if (side === "Bottom") return parts[2];
    return parts[1];
  }
  var map = {
    Top: 0,
    Right: 1,
    Bottom: 2,
    Left: 3
  };
  return (_parts$map$side = parts[map[side]]) !== null && _parts$map$side !== void 0 ? _parts$map$side : 0;
}
export function getSpacingSideValue(style, property, side) {
  if (!style) return 0;
  var sideKey = property + side;
  if (style[sideKey] !== undefined) {
    return parsePxValue(style[sideKey]);
  }
  if (style[property] !== undefined) {
    return parsePxFromShorthand(style[property], side);
  }
  return 0;
}

/** Resolve margin/padding CSS from style, supporting shorthand and per-side values. */
export function buildSpacingCss(style) {
  var _ref49 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref49$marginFallback = _ref49.marginFallback,
    marginFallback = _ref49$marginFallback === void 0 ? "0" : _ref49$marginFallback,
    _ref49$paddingFallbac = _ref49.paddingFallback,
    paddingFallback = _ref49$paddingFallbac === void 0 ? "0" : _ref49$paddingFallbac;
  var parts = [];
  if (hasIndividualSpacing(style, "margin")) {
    SPACING_SIDES.forEach(function (s) {
      var val = style === null || style === void 0 ? void 0 : style["margin".concat(s.key)];
      if (val !== undefined && val !== null && val !== "") {
        parts.push("margin-".concat(s.key.toLowerCase(), ": ").concat(val));
      }
    });
  } else {
    var _style$margin;
    parts.push("margin: ".concat((_style$margin = style === null || style === void 0 ? void 0 : style.margin) !== null && _style$margin !== void 0 ? _style$margin : marginFallback));
  }
  if (hasIndividualSpacing(style, "padding")) {
    SPACING_SIDES.forEach(function (s) {
      var val = style === null || style === void 0 ? void 0 : style["padding".concat(s.key)];
      if (val !== undefined && val !== null && val !== "") {
        parts.push("padding-".concat(s.key.toLowerCase(), ": ").concat(val));
      }
    });
  } else {
    var _style$padding;
    parts.push("padding: ".concat((_style$padding = style === null || style === void 0 ? void 0 : style.padding) !== null && _style$padding !== void 0 ? _style$padding : paddingFallback));
  }
  return parts.join("; ");
}

/** Inset frame drawn as an overlay so it stays visible over nested backgrounds. */
export function getInnerBorderFrame() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var borderStyle = style.innerBorderStyle;
  if (!borderStyle || borderStyle === "none") return null;
  var width = style.innerBorderWidth || "1px";
  var color = style.innerBorderColor || "#d4af37";
  var insetParsed = parseInt(style.innerBorderInset, 10);
  var insetPx = Number.isFinite(insetParsed) ? Math.max(0, insetParsed) : 24;
  return {
    width: width,
    borderStyle: borderStyle,
    color: color,
    insetPx: insetPx
  };
}
function resolveInnerBorderOverlayRadius() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var insetPx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!style) return null;
  var _parseCssLength = parseCssLength(style.borderRadius, 0, "px"),
    outerRadius = _parseCssLength.value,
    unit = _parseCssLength.unit;
  if (!Number.isFinite(outerRadius) || outerRadius <= 0) return null;
  var innerRadius = Math.max(0, outerRadius - insetPx);
  if (innerRadius <= 0) return null;
  return "".concat(innerRadius).concat(unit || "px");
}
function buildInnerBorderOverlayCss() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var frame = getInnerBorderFrame(style);
  if (!frame) return null;
  var radius = resolveInnerBorderOverlayRadius(style, frame.insetPx);
  var parts = ["position:absolute", "top:".concat(frame.insetPx, "px"), "right:".concat(frame.insetPx, "px"), "bottom:".concat(frame.insetPx, "px"), "left:".concat(frame.insetPx, "px"), "border:".concat(frame.width, " ").concat(frame.borderStyle, " ").concat(frame.color), "pointer-events:none", "z-index:20", "box-sizing:border-box", "-webkit-print-color-adjust:exact", "print-color-adjust:exact"];
  if (radius) parts.push("border-radius:".concat(radius));
  return parts.join(";");
}
export function getInnerBorderOverlayStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var frame = getInnerBorderFrame(style);
  if (!frame) return null;
  var radius = resolveInnerBorderOverlayRadius(style, frame.insetPx);
  return _objectSpread({
    position: "absolute",
    top: frame.insetPx,
    right: frame.insetPx,
    bottom: frame.insetPx,
    left: frame.insetPx,
    border: "".concat(frame.width, " ").concat(frame.borderStyle, " ").concat(frame.color),
    pointerEvents: "none",
    zIndex: 20,
    boxSizing: "border-box",
    WebkitPrintColorAdjust: "exact",
    printColorAdjust: "exact"
  }, radius ? {
    borderRadius: radius
  } : {});
}
export function buildInnerBorderOverlayHtml() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var css = buildInnerBorderOverlayCss(style);
  if (!css) return "";
  return "<div aria-hidden=\"true\" style=\"".concat(css, "\"></div>");
}

/** Inject inner-border overlay inside the styled root element (keeps inset even with margin/padding). */
export function injectInnerBorderIntoHtmlMarkup(nodeMarkup) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var overlay = buildInnerBorderOverlayHtml(style);
  if (!overlay) return nodeMarkup;
  var trimmed = nodeMarkup.trimStart();
  var tagMatch = trimmed.match(/^<([a-z0-9]+)\b([^>]*)>/i);
  if (!tagMatch) {
    return "<div style=\"position:relative;\">".concat(overlay).concat(nodeMarkup, "</div>");
  }
  var _tagMatch = _slicedToArray(tagMatch, 3),
    fullOpen = _tagMatch[0],
    tagName = _tagMatch[1],
    attrs = _tagMatch[2];
  var newAttrs = attrs;
  var styleMatch = newAttrs.match(/\bstyle="([^"]*)"/i);
  if (styleMatch) {
    var existing = styleMatch[1].trim();
    var positionMatch = existing.match(/position\s*:\s*([^;]+)/i);
    var position = positionMatch ? positionMatch[1].trim().toLowerCase() : "";
    // Absolute/fixed/sticky/relative already establish a containing block for the overlay —
    // do not rewrite them to relative (that broke free-positioned blocks in preview/PDF).
    if (!position || position === "static") {
      var updated = existing ? "position:relative;".concat(existing) : "position:relative;";
      newAttrs = newAttrs.replace(styleMatch[0], "style=\"".concat(updated, "\""));
    }
  } else {
    newAttrs = "".concat(newAttrs, " style=\"position:relative;\"");
  }
  var newOpen = "<".concat(tagName).concat(newAttrs, ">");
  return trimmed.replace(fullOpen, "".concat(newOpen).concat(overlay));
}
export function hasPerSideBorderWidth(style) {
  return ["Top", "Right", "Bottom", "Left"].some(function (side) {
    return (style === null || style === void 0 ? void 0 : style["border".concat(side, "Width")]) !== undefined;
  });
}

/** Prefer border longhands over a conflicting `border` shorthand (e.g. border: "none"). */
export function resolveBorderStyleProps() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = _objectSpread({}, style);
  var perSide = hasPerSideBorderWidth(next);
  if (perSide) {
    delete next.border;
    delete next.borderWidth;
    if (next.borderStyle && next.borderStyle !== "none" && !next.borderColor) {
      next.borderColor = "#101828";
    }
  } else if (next.borderStyle && next.borderStyle !== "none") {
    delete next.border;
    if (!next.borderWidth || next.borderWidth === "0px") next.borderWidth = "1px";
    if (!next.borderColor) next.borderColor = "#101828";
  } else if (next.border && next.border !== "none") {
    // keep shorthand custom border if no longhands
  } else {
    delete next.border;
  }
  // Inner frame is rendered as an overlay element, not CSS outline
  delete next.innerBorderStyle;
  delete next.innerBorderWidth;
  delete next.innerBorderColor;
  delete next.innerBorderInset;
  delete next.outline;
  delete next.outlineOffset;
  return next;
}

/** Resolve block layout gap from style, falling back to a type default (e.g. gallery 12px). */
export function resolveBlockGap(style) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "12px";
  if ((style === null || style === void 0 ? void 0 : style.gap) !== undefined && style.gap !== null && style.gap !== "") {
    return style.gap;
  }
  return fallback;
}

/** Resolve one side from a CSS shorthand string (supports 1–4 values + units). */
export function getShorthandSideLength(val, side) {
  var _parts$map$side2;
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var fallbackUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "px";
  var parts = String(val || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return parseCssLength("", fallback, fallbackUnit);
  if (parts.length === 1) return parseCssLength(parts[0], fallback, fallbackUnit);
  if (parts.length === 2) {
    return parseCssLength(side === "Top" || side === "Bottom" ? parts[0] : parts[1], fallback, fallbackUnit);
  }
  if (parts.length === 3) {
    if (side === "Top") return parseCssLength(parts[0], fallback, fallbackUnit);
    if (side === "Bottom") return parseCssLength(parts[2], fallback, fallbackUnit);
    return parseCssLength(parts[1], fallback, fallbackUnit);
  }
  var map = {
    Top: 0,
    Right: 1,
    Bottom: 2,
    Left: 3
  };
  return parseCssLength((_parts$map$side2 = parts[map[side]]) !== null && _parts$map$side2 !== void 0 ? _parts$map$side2 : "", fallback, fallbackUnit);
}

/**
 * Column layouts: columnGap applies between columns horizontally.
 * Stack gap between nested blocks inside a column is kept at 0 (consistent with canvas)
 * so column gap does not inadvertently separate headings, text, and other child blocks.
 */
export function getColumnLayoutGapConfig(type, style, columnCount) {
  var _BLOCK_GAP_DEFAULTS$t;
  var isSingleColumn = type === "one-column" || columnCount <= 1;
  var fallback = "".concat((_BLOCK_GAP_DEFAULTS$t = BLOCK_GAP_DEFAULTS[type]) !== null && _BLOCK_GAP_DEFAULTS$t !== void 0 ? _BLOCK_GAP_DEFAULTS$t : isSingleColumn ? 0 : 24, "px");
  var gap = resolveBlockGap(style, fallback);
  return {
    isSingleColumn: isSingleColumn,
    columnGap: isSingleColumn ? 0 : gap,
    stackGap: "0"
  };
}
export function getRadiusCornerLength(style, cornerKey) {
  if (!style) return {
    value: 0,
    unit: "px"
  };
  if (style[cornerKey] !== undefined) {
    return parseCssLength(style[cornerKey]);
  }
  return parseCssLength(style.borderRadius);
}
export function getRadiusCornerValue(style, cornerKey) {
  return getRadiusCornerLength(style, cornerKey).value;
}
export function hasIndividualSpacing(style, property) {
  return SPACING_SIDES.some(function (s) {
    return (style === null || style === void 0 ? void 0 : style[property + s.key]) !== undefined;
  });
}

/** Move padding/margin off nested elementStyles onto the block shell (layout belongs on the block). */
export function liftElementSpacingToBlock(node) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "padding";
  if (!(node !== null && node !== void 0 && node.elementStyles) || _typeof(node.elementStyles) !== "object") {
    return node;
  }
  var keys = [property, "".concat(property, "Top"), "".concat(property, "Right"), "".concat(property, "Bottom"), "".concat(property, "Left")];
  var changed = false;
  var liftedStyle = null;
  var nextElementStyles = _objectSpread({}, node.elementStyles);
  Object.keys(nextElementStyles).forEach(function (elementKey) {
    var elStyle = nextElementStyles[elementKey];
    if (!elStyle || _typeof(elStyle) !== "object") return;
    if (!liftedStyle && !styleHasSpacing(node.style, property) && styleHasSpacing(elStyle, property)) {
      liftedStyle = {};
      keys.forEach(function (key) {
        if (elStyle[key] !== undefined) liftedStyle[key] = elStyle[key];
      });
    }
    var cleaned = _objectSpread({}, elStyle);
    keys.forEach(function (key) {
      if (cleaned[key] !== undefined) {
        delete cleaned[key];
        changed = true;
      }
    });
    nextElementStyles[elementKey] = cleaned;
  });
  var nextNode = node;
  if (liftedStyle) {
    nextNode = _objectSpread(_objectSpread({}, nextNode), {}, {
      style: _objectSpread(_objectSpread({}, nextNode.style || {}), liftedStyle)
    });
    changed = true;
  }
  return changed ? _objectSpread(_objectSpread({}, nextNode), {}, {
    elementStyles: nextElementStyles
  }) : node;
}
export function hasIndividualRadius(style) {
  return RADIUS_CORNERS.some(function (c) {
    return (style === null || style === void 0 ? void 0 : style[c.key]) !== undefined;
  });
}

/** Inline border-radius CSS for export/PDF (matches canvas clipping on images/buttons). */
export function buildBorderRadiusCss(style) {
  var _ref50 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref50$circle = _ref50.circle,
    circle = _ref50$circle === void 0 ? false : _ref50$circle;
  if (circle) return "border-radius: 50%;";
  if (!style) return "";
  if (hasIndividualRadius(style)) {
    var parts = RADIUS_CORNERS.filter(function (c) {
      return style[c.key] !== undefined && style[c.key] !== null && style[c.key] !== "";
    }).map(function (c) {
      var kebab = c.key.replace(/[A-Z]/g, function (m) {
        return "-".concat(m.toLowerCase());
      });
      return "".concat(kebab, ": ").concat(style[c.key]);
    });
    return parts.length ? "".concat(parts.join("; "), ";") : "";
  }
  if (style.borderRadius !== undefined && style.borderRadius !== null && style.borderRadius !== "") {
    return "border-radius: ".concat(style.borderRadius, ";");
  }
  return "";
}
export function getBackgroundImageUrl(style) {
  var bg = style === null || style === void 0 ? void 0 : style.backgroundImage;
  if (!bg || bg === "none") return "";
  var match = String(bg).match(/url\(["']?([^"')]+)["']?\)/);
  return match ? match[1] : "";
}

/** Default dark tint when a block background image is first set (PandaDoc-style). */
export var DEFAULT_BACKGROUND_OVERLAY_OPACITY = 40;
export function getBackgroundOverlayOpacity(style) {
  var raw = style === null || style === void 0 ? void 0 : style.backgroundOverlayOpacity;
  if (raw === undefined || raw === null || raw === "") return 0;
  var n = Number(raw);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}
export function getBackgroundOverlayColor(style) {
  var color = style === null || style === void 0 ? void 0 : style.backgroundOverlayColor;
  if (!color || color === "transparent") return "#000000";
  return String(color);
}
export function hexToRgba(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var raw = String(color || "#000000").trim();
  var a = Math.max(0, Math.min(1, Number(alpha) || 0));
  if (raw.startsWith("rgba(") || raw.startsWith("rgb(")) {
    var nums = raw.match(/[\d.]+/g) || [];
    var _r2 = nums[0] || 0;
    var _g = nums[1] || 0;
    var _b = nums[2] || 0;
    return "rgba(".concat(_r2, ", ").concat(_g, ", ").concat(_b, ", ").concat(a, ")");
  }
  var hex = raw.replace("#", "");
  if (hex.length === 3) {
    hex = hex.split("").map(function (c) {
      return c + c;
    }).join("");
  }
  if (hex.length !== 6) {
    return "rgba(0, 0, 0, ".concat(a, ")");
  }
  var r = parseInt(hex.slice(0, 2), 16);
  var g = parseInt(hex.slice(2, 4), 16);
  var b = parseInt(hex.slice(4, 6), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}

/**
 * CSS url() safe for inline HTML style="..." attributes.
 * Double quotes inside url() break the attribute and wipe the whole style block.
 */
export function formatCssUrl(url) {
  var raw = String(url || "").trim();
  if (!raw) return "none";
  var escaped = raw.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, "%22");
  return "url('".concat(escaped, "')");
}

/** Compose overlay gradient + image url for CSS background-image. */
export function composeBackgroundImageLayers(style) {
  var url = getBackgroundImageUrl(style);
  if (!url) return (style === null || style === void 0 ? void 0 : style.backgroundImage) || "none";
  var opacityPct = getBackgroundOverlayOpacity(style);
  var imageLayer = formatCssUrl(url);
  if (opacityPct <= 0) return imageLayer;
  var rgba = hexToRgba(getBackgroundOverlayColor(style), opacityPct / 100);
  return "linear-gradient(".concat(rgba, ", ").concat(rgba, "), ").concat(imageLayer);
}

/**
 * Resolve style for canvas/HTML: compose bg image + overlay, strip custom overlay props.
 */
export function resolveStyleWithBackgroundOverlay() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = _objectSpread({}, style || {});
  if (getBackgroundImageUrl(next)) {
    next.backgroundImage = composeBackgroundImageLayers(next);
    if (!next.backgroundSize) next.backgroundSize = "cover";
    if (!next.backgroundPosition) next.backgroundPosition = "center";
    if (!next.backgroundRepeat) next.backgroundRepeat = "no-repeat";
  }
  delete next.backgroundOverlayOpacity;
  delete next.backgroundOverlayColor;
  return next;
}
export function getColumnBackground(style, index) {
  var bgs = style === null || style === void 0 ? void 0 : style.columnBackgrounds;
  if (!Array.isArray(bgs)) return "";
  var bg = bgs[index];
  if (!bg || bg === "transparent") return "";
  return bg;
}